import { Menu, Avatar, Typography, Alert, Row, Col, Divider, Dropdown, Layout as Layout$1, Button, Popover, Card, Spin, Empty, Tag, List, Modal, Table, Select, Radio, Form, InputNumber, DatePicker, Space, Result, Input } from 'antd';
import * as React from 'react';
import React__default, { useCallback } from 'react';
import { Link, Route } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { identity as identity$1, pipe, constVoid } from 'fp-ts/lib/function';
import { record, either, option, eq, string, array, boolean, number, date as date$2, ord, io, taskEither, task } from 'fp-ts';
import { useSelector, useDispatch } from 'react-redux';
import { WalletFilled, ShopOutlined, CreditCardOutlined, FundFilled, SettingFilled, LineChartOutlined, UserOutlined, AppstoreOutlined, BankOutlined, ArrowLeftOutlined, ArrowRightOutlined, InfoCircleOutlined, CloseCircleFilled, DownOutlined, CalendarOutlined, FilterOutlined } from '@ant-design/icons';
import * as t from 'io-ts';
import { string as string$1 } from 'io-ts';
import { withFallback, DateFromISOString } from 'io-ts-types';
import { pipeable, pipe as pipe$1 } from 'fp-ts/lib/pipeable';
import { identity } from 'fp-ts/es6/function';
import { optionFromNullable } from 'io-ts-types/lib/optionFromNullable';
import { sequenceT } from 'fp-ts/lib/Apply';
import axios from 'axios';
import * as effects from 'redux-saga/effects';
import { FormattedMessage, FormattedDate } from 'react-intl';
import moment from 'moment';
import PhoneInput, { getCountryCallingCode } from 'react-phone-number-input';
import { combineReducers } from 'redux';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var ProsperUSLogo = (function () { return (React.createElement("svg", { width: "23", height: "32", viewBox: "0 0 23 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M13.5058 0.205128C7.17612 -0.965685 1.35865 2.98581 0.26101 9.24234C-0.141457 11.4376 0.041483 13.6695 0.041483 15.9013C0.00489508 20.7309 0.041483 25.5605 0.041483 30.4267C0.041483 31.3414 0.297598 31.9634 1.35865 32C2.4197 32 2.7124 31.3414 2.7124 30.4633C2.7124 30.2438 2.67581 29.9511 2.67581 29.7316C2.67581 26.1825 2.67581 22.6335 2.67581 19.1211C2.82216 19.0479 2.93193 18.9747 3.07828 18.9015C3.2978 19.1942 3.44416 19.5235 3.66368 19.7431C7.02977 22.9628 10.9813 23.6946 15.2986 22.231C19.5062 20.8407 21.8844 17.7673 22.6894 13.4134C23.8968 7.23 19.7989 1.41253 13.5058 0.205128ZM11.3837 20.4382C6.18825 20.3285 2.56605 16.5233 2.67581 11.2547C2.74899 6.20554 6.59071 2.4004 11.5301 2.51016C16.506 2.58334 20.3112 6.57142 20.238 11.6571C20.1648 16.6331 16.2133 20.5846 11.3837 20.4382Z", fill: "white" }),
    React.createElement("path", { d: "M11.6398 17.3648C9.33481 17.3283 7.43224 16.5599 6.00531 14.7671C5.74919 14.4378 5.31014 13.9622 5.78578 13.6329C6.22484 13.3036 6.37119 13.9622 6.6273 14.2183C9.33481 17.4014 13.9815 17.3283 16.7256 14.1085C16.9451 13.889 17.0549 13.3402 17.4573 13.5963C17.933 13.889 17.6037 14.2915 17.3841 14.6208C15.884 16.5233 13.8717 17.3283 11.6398 17.3648Z", fill: "white" }),
    React.createElement("path", { d: "M17.128 8.32764C17.0914 8.76669 17.2012 9.09599 16.8719 9.27892C16.5426 9.42528 16.3231 9.20575 16.1036 8.98622C15.8109 8.65693 15.445 8.36423 15.2255 7.96176C14.8962 7.41294 14.0546 6.71777 14.7864 6.20554C15.4084 5.80308 16.1402 6.53483 16.5792 7.12024C16.8719 7.55929 16.9817 8.03494 17.128 8.32764Z", fill: "white" }),
    React.createElement("path", { d: "M6.11507 8.29105C6.18825 8.07152 6.18825 7.852 6.29801 7.59588C6.66389 6.79095 7.17612 6.16895 8.09082 6.0226C8.27376 5.98601 8.56646 6.09578 8.60305 6.16895C8.78599 7.01047 8.16399 7.52271 7.76153 8.1447C7.61518 8.36423 7.39565 8.62034 7.17612 8.80328C6.95659 9.02281 6.70048 9.3521 6.29801 9.13257C6.00531 8.94963 6.0419 8.62034 6.11507 8.29105Z", fill: "white" }))); });

var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQwAAABACAYAAADvYUkwAAAAAXNSR0IB2cksfwAAEopJREFUeJztnXuMFdUdx0+tb2sLPlBUdHmq9VGMWXZp04qPhki5sCmlxhjK0pD0nyYs6h/2IRhjaRUpG2MsMalsDLRgjJqusek/cME0xkRl2SYaIYS7QFZRcO8Cu8IV9vZ8Z87vzrnnztw589q76O+b/MLl7sw5M3Pn95nfOed3zgjBYrFYLBaLxWKxWN8YfSuBsVisb4hM5z8ngjE4WKxviPwg8W3Nzg0x2o7hwWJ9zeUHCkDgPGXnS7ugjp2v7DxRCw+GBov1NZEZVeigAAgulHaRtIulXaLsO5rRdxer7S4UHkB0eOjgYLFYZ6nqgQIQABS+K+170sZJG6/sMu3zOPV3bHepcAFykfDAwdBgsc5y+UUVcG4CBRwfEAAYrpB2pbSrpF1t2FXKrlTbYXsABPDQwUHRBjdRWKyzTEGwgHPDyeHscHxAAFC4Rtp10iZJu17ZDdrnServ16jtJ0i7XLjgAHgAoAuFF21wpMFinUXSgaHDAs0PODmcHVEDIAAwTH7ggQd+0NPTs2x4eHjTV199tWNkZKSnXC4PnD59esepU6f+1d/f/4f169fPVtsDIIAHwAHwIFIBiBgaLNZZpjBYoFkBZ4fTT168ePHMwcHBFyQgBqSVwwww2blz5y/kvk3CBc5E4QJIhwaaJ3qfBovFGqPSmyJwXDgwwQJNEMACUcKUDz744NdnzpwZkFaOaidPnux+8MEHbxduk2WiKpugQX0aDA0WawzLjC7guOhfgCNTZAFYTN2zZ88K2dwow2TU4FixWPznu+++uzyXyzXLbW6SdiP+femll+b39fWtkk2TPtoW+5VKpcKrr746V3jQQB3fVXVy04TFGuPSowtqiqBTEv0M6KyEY089cODA4wQK6fTl4eHhtx977LF7hAuJGdKmS5umbLr6Dn+7ube392G5TxH7KXAMoP9DuE0c9ItgGBYRjd40YWCwWGNQZnSB5gGiCzQX0N8wecuWLffrsDh69OgW+f33hQsEAkWTZpOlTREeNG7ZsGHDwqGhoV6Chvx3t9ruWlVXUJTBYrHGiOgpbvZdUHSBpsg0CYsCwUI2Qd4SHiymqUgBUQjgcq2y69R3AAKAcrO0Wx999NH7Tp486UQaANCRI0eeVtuhLj3K4GYJizUG5dccwZOe+i4m79u3bwVFF6dOnSrOnTt3llCRhYTHK2WpN9988z7hJWth2BQAmIghVfz9008//btwIXPba6+99pAsp9I0WbJkya2qLoyaXKqOgTs/WawxJr+hVDQJMDICp0eUMFU69k4Cxt69e1cLBYuPPvroYcDgyy+/fEttD8jA6S8TXs7GRAmH/2K77u7uh+T/b5F2m2yavE2doIcOHfqjqsvs/GRgsFhjSH6jI+i/QNMAzn79okWL7sBwKAFDjYSgiTEFIJDf/W/lypXov7hc7UdzRwAdgGPCiy++2DwyMjJ4/Pjx/wjVn7Fjx47fEDDkvz3C7fycoPZnYLBYY1A6MGhyWVX/xbZt236JxCs4towk3hZuJ+ZU/A3NEAULmieiz1alOScAyQRsi4hEuLC5ad68eS0EDJQv3H6MCaocQKshHZ8yEBoHG636IHldm0arLpybvO53jWadJNQ5mvWirlKpNNNm2zkz21L/zX/YPM+q7iDhmGY35+7K4tjiygSG3uGJ/Igm2Vx4HA6NKOPw4cPPCBcY6MhEEwJRCGVr0twQms5OM1opSxTbIoqgkZOb5Y/Zi3JR/nPPPdcqvOFVJ4nr2LFjDw8PD3cWi8Xx+kHjppf7rpC2HZ2nmuH/S6NcABkltcl91kvbb5RVVqM5r6OutG50dROjvl1+9alzWJEWtNS1WqrOY8CnvgE6x7RBCWetc6643htl3XOilquuIa7TdvOY5XftPveFU19QXbNn5dpaZ+XKLbNyA62tbU2xTra2zDfcMhfsirJfa3OuXR7H69jXNOf4WnIbW2ctiHSPpym/ERI4PiCATsimL7744mkDGIgQMHKCkRBEBONF9UQyWvdChwa2oWzRJlXGTegbIWC89957bUIDRl9f308lLJAZCuukA5YO/kTAja9bKNlx8wRBoo5tTOJU6tht64Ijr45bF6SgGnatquqEgycFh+bQtvVujwIO4zp2qHOdWQfCZJ1+5UkHfIKcEvBIcu5emfOLVKbN9ohGABc/UATY/tbW+XPSONYoCgPGZAIGTAJjrfCAQRma+lwQc7UtmuVqZoyiGeMAg8o2gSEjm8UEDHmD7FJPSpubMB920nKbrqB98TfckPLY3pCfewIceU7UCx1QZw/qUQ7QGVBfzVM0TOpaBTlPns5T/VuI8jQOk4rY/CDVo65pp6q3aG5jC0gdGOq3muNTZ97HfB8k0vnyniMueCLOefuUWbYFBhzfiR6qgOAAJz+7eX6nAlpeh1DFZESSxvHaKggYcG5EEFOOHj36DEY44NT4LNzmRJPwhkFpfQuacUpG0CBgYFtAxkkxl3ajjC4KKBdavnw58jQADKcPQ8LpPg0YFMLqN0N71GZCgCPBYdqDnFLt0+Fzg7fb1qv2p/2KuMlD6us06tplCw31pK1xHjhyyD5+QLM+R1VOu7F/3XNVjp439tkYVo8RYejnWoh6zFAjgYEmkAGLfL3IAYCQ2xQaBY0wYEwlYEDyx0CnJ+aJTF63bl3r7t27fyW8zk59JS2ChT6B7Ypt27Yt2rRp0/3y87S2trY7CRaQcPtEKp2eAIYEgg6MWDexLvWECw1R/aQ6C6v2r+eEugzYWHWEKWfS9+uwOcZSbTOr3aY+dZwzzSjHNtJQ+1ZFFLZA9wFN3WMOaNr1xG1K6cBIr0liCYzq5tAbNmWjE1Ru36P3baRxzDbyAwYlbcGBp+nAUI6NPIrpSLaSzjz44YcfLhFelKGv36kv43dZd3f3vTJiOPjkk0/+GPvv3bu3g8o8ffr0TuGlhzvDqgHAaI97oj43WayyjCfxQJhTKMePDChV10z11CzaOJ/qvKw83W3hpEtBR4fGgI0jGvtEdl4DGnWvq89vWUjS71IVYaTUL1AVAdSLGDTHjzoaIvfpckAjmy2JD9hSJjAoyxOOixGN6Z9//vlaHRgff/zxSuHmUkzdunXrXEDj0KFDvxfeKlo1w6qFQuFxwOLll1+eJ9z+ixlYYIfK/Oyzz7A/mjiUuHWRDzDycU9SOUEldMUNF7csyHCOrpBtO9Kqt54MMCWCq7pehQjnqDt7Ma7zGiAIrNMERtz+FlKDgTHqUUISRQaGbEYUkEMhtKbJ4ODgv6VzH+jv7//d+++/nyMDSPD9kSNHXlmzZs2PhNt3MUOPLqBly5YhZRx5HxjOdeaSyH3uBTAAC2WxQ0XjButJcsEgNQpQuWHrPQ11R84YGHpzKZ9CeXNsz7FU3Q/RHrdOBapKMywIPMbvWYhbH6nBwKj0R6RRb9YKA8YMExjQiRMn/iH/hvkflJMxqbOzs2X//v2rJCSelc2YrfhXNlc61q5di+X5moSCxebNm+fJIgaorKGhoReE1xyhpK0LAAy9OZLkJPWnZdKnkVam3jQJ7F9QTlAZfcgiKcwEWIrnGAoCo+5iCnV2htVpG4nYqsHA6Kr0YbTkQvupGq1YwICKxeIG4fZnINIADAAOfQFgfG4SbqIWhmJvBCzOnDmzWyumoEUXNOKCYzhfln9PGs2RUnVnXCFuOabU8GFlFCPkGHQn2JWWQwccSyGtcvWmBiKYsG3ScF6biMwcVk1aZ0OBIf9mDKcmyr3JWpGAgUlmYAX9X/5Y3atWrbpbeAvo0OI5U4WxiA5W6tIjC5SjZrheI4zoQtq5AAY1RxICQx/STLVzSH+q19vOpyPRiTakrUeadtLjMJ64qZ2jET34QjHtp70Bv3xYnWc7MCA316I2o7OlJbdwLKWFQ5GA0d/f/1fZ9FisQwMaHh7ejHU+hbc8n2NPPfXUT9SSfjvK1Sq+8847PxfV2aI0NOtMOiNgJG2Tp31z6dKbOmHbln2GZQ3bRSnapYijGxmfY10olmrzNwDC7THNzJHJh51vULMlihoNDAjNkbpZnc257Yg+MLckjeOLq6BhVd9Oz08++WSd/K7lkUcemSubFr1+TRWlgaA/YAhVRRYEC3R0Umq5E11IO0c+3e5OGxhpNwX0Nr5t2dguBBwVgNh29PqlSqelMCiWahOv0rSusPNN4zeleR+NBIazT2tbk96nEWRuotf81Y2IPiLlYShg3CntDmm3Y4h1ZGSkrw44qkBx8ODB3wrvFQOA0njhrX9RtWJ4FsBI42mkS29mlGOkb6vwOzBVWjnE62Fll7Q+kgZEGHr/DM7BSa1PagBf0HmnDQw9eaqRwCA5s1Rn5dpUU8U/JZzAMcrzSSJleh4+fPhZ+R2W48MICVK5nX6L3t7eZcePH/8boCABshuGz/KH3QRIPP/88xiGJVD4vf2s5vUCxrBePu4JNjJcjyrVZ9BRqu3vCOtUzY/COfqOgGR5fYOUKTAySA1Pw6md6KM5114VDaWcnWoj67kkEJonwhsZQaemPjIySXivRiRDhyYgQe9YJVD4vV+16qXMaQEjrXJMlTIafSGZqeH1nNFoFuTTOgbLDsg2BoZfmekCo6pst+mS1yON0WqeWM1WJWCoyWc0jEpT3AkItJYnGb2EWV+Ji97gbr5TteYN7mk5erk6DyJy0yFIRiieSWquAaXATECzHyGjc/TtG7EZSUlb2QIj15X8CLMFhlaHNwdmlHI4rNbDMICByOIG4b0jldbwBBTGaUZL9VG6OM0zoQlq9Nb2GlhAaUYGRidjV5KyoLKRap52Z6qukkXHqgmMNJ70UbJZjSZUolWmbJRBp2eb97SOtuCNn1QEkDkw9OMGPLKow1Q9YDhT0XVg4LPwVtvSX6hMULhEMwIETUajpse5wh8UVcvwpQwMc55FopvaePImOrYoddkCo2QxKS5MxkS2fMgx6slb25PUa6PUI4yUHdzMq8gswqhO+spnUYepeu8kATCuLxaLfyFg4LPwXm+ov0hZhwIZrYtxnqiOJuqCgpR234PhVFYzMAPKqZqKHXbDqjZ+7CXVbJ7ePsBI1DwoVSe7hZ5juXayWuiaFkmUxVB5VS5Gcy429NyVs4zFcAKA4U5TX7A07rKAeoRhOzU+qXRg0KrhtKSeswanDzBoLU892YqiBz2C0AFBkDBBEbi4b9rAUCG2PnQ5EDXSMGER1neh90HYDI+aMq5BoU49QbkQ1gvvaGWtiNO88YniIkFDQWejzXXKBBhminZLLjL03MVwfJbZCwCGt+5nvOFRA3LtUfePo6DXDNB7Sa49duzYnwkY+Cy8VG56HYDe1NDBoJsJidBVwLMY3SjVLvLiLAsXdoMCNkaIHji3wtzPgJT10nfmUnchK2bpwDBXB9tvE+EErMPZZXOs2nGYQLU6X7Wf9fIDWSXj1TQlkF1p4ciIFFpaFqyoXWavPjBqk7TskrGcyMRZDLiybyHyycZU0IuMKHnrah0YJ06cWCPc6IKyMymVO6hPIhIkdGU8HOq3niSAgNW17yLD09YERVRHUo5v1oc08NV6Xaq+pXjKlmpXzapbX8noGFXOHzh3xawz4Bxjjfz4QKNSt7wWC41zXV+qXU4wdLGgLLN3AzIt98OZMbcDqdlkChI1K3zb9mGolbPy+rb6yuDVdeUW4hjcFPEqyBSTvs4ginRg6PNJAANnpW9AgoAxNDT0J+GCRJ8oVpNDIVJ4j0hWwIDK4fM6gqwQZ10O5cBxUqgBmtDhMhMY9L1yLN8M0nrnmNQJSz5L/dkYfhObJlSWwIBU30DBBxxhlifn1fcPc+gawNhbYTRhAekOrvdjUJQxfs+ePT8ru5PNivv27cOKWZShqUcXqb80uVTdfMgkz0Gb1xHmVLj5A1OVo9RXcidrhdVXqLd4rqkgYEAKVhhpKdSrU12H9iTn53Nc7RZgLqprYn3jaw8Tq6UL48rLrPRPzdY7HM0oQoOA1YJN7kiNkw9iA6qeRq+dYTZLMOKBCAJgwE1LORb6C4uCoovUVHLb412j8bYsdRN26PMZKLzPoj44iFln3PrqAcOsExGSeY5pJXqFHKN+vm1Jr+1ov0UNT3K3YxROLQ2rd2c2XOqmgVfqUuZEPim9aCmpzCiDoEEL+ZLVTece9aNmObIFBouVlsy+DIIGvSqA8iwonZtGRRgWY0AMDFYj5AcNGODgl4ClD5myGigGBqtR0qFB4PCzVEdEWMnEwGA1UjoIbJKwWA0WA4M1FlQvAYtBMYbEwGCxWNZiYLBYLGsxMFgslrWMbMpRTRVmsVhnmVQafT6rFHoWi8VisVgsFovFYrFYLBaLxWKxWCwW6+uh/wN4MeIDE0p5nwAAAABJRU5ErkJggg==";

var Module = t.keyof({
    WEB_WALLET: {},
    MARKETPLACE: {},
    PROSPERBILL: {},
    DASHBOARD: {},
    BACKOFFICE: {},
    REWARDS: {},
    ASSET_MANAGEMENT: {},
    SMART_HUB: {},
    ANALYTICS: {},
    CLEARING: {},
});
var applicationDefinitions = {
    WEB_WALLET: {
        icon: React.createElement(WalletFilled, null),
        href: '/web-wallet',
        descriptionKey: 'WEB_WALLET-description',
    },
    MARKETPLACE: {
        icon: React.createElement(ShopOutlined, null),
        href: '/marketplace',
        descriptionKey: 'MARKETPLACE-description',
    },
    PROSPERBILL: {
        icon: React.createElement(CreditCardOutlined, null),
        href: '/prosper-bill',
        descriptionKey: 'PROSPERBILL-description',
    },
    DASHBOARD: {
        icon: React.createElement(FundFilled, null),
        href: '/dashboard',
        descriptionKey: 'DASHBOARD-description',
    },
    BACKOFFICE: {
        icon: React.createElement(SettingFilled, null),
        href: '/backoffice',
        descriptionKey: 'BACKOFFICE-description',
    },
    REWARDS: {
        href: '/rewards',
        icon: (React.createElement("span", { className: "anticon" },
            React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 34 34", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M30.75 0.333344C32.36 0.333344 33.6666 1.63834 33.6666 3.25001V8.32001C33.6668 9.15758 33.4374 9.97916 33.0034 10.6955C32.5694 11.4119 31.9474 11.9956 31.205 12.3833L20.735 17.85C22.4124 18.691 23.7569 20.0736 24.5508 21.7738C25.3447 23.4741 25.5415 25.3925 25.1093 27.2185C24.6772 29.0446 23.6414 30.6713 22.1697 31.8354C20.698 32.9995 18.8764 33.6328 17 33.6328C15.1235 33.6328 13.302 32.9995 11.8303 31.8354C10.3585 30.6713 9.32276 29.0446 8.89063 27.2185C8.4585 25.3925 8.65531 23.4741 9.44919 21.7738C10.2431 20.0736 11.5876 18.691 13.265 17.85L2.79498 12.3833C2.05256 11.9956 1.43057 11.4119 0.996579 10.6955C0.562591 9.97916 0.333196 9.15758 0.333313 8.32001V3.25001C0.333313 1.63834 1.63998 0.333344 3.24998 0.333344H30.75ZM17 19.4667C15.4529 19.4667 13.9692 20.0813 12.8752 21.1752C11.7812 22.2692 11.1666 23.7529 11.1666 25.3C11.1666 26.8471 11.7812 28.3308 12.8752 29.4248C13.9692 30.5188 15.4529 31.1333 17 31.1333C18.5471 31.1333 20.0308 30.5188 21.1248 29.4248C22.2187 28.3308 22.8333 26.8471 22.8333 25.3C22.8333 23.7529 22.2187 22.2692 21.1248 21.1752C20.0308 20.0813 18.5471 19.4667 17 19.4667ZM22.8333 2.83334H11.1666V13.9367L16.8066 16.8817C16.8663 16.9129 16.9326 16.9292 17 16.9292C17.0673 16.9292 17.1337 16.9129 17.1933 16.8817L22.8333 13.9333V2.83334ZM8.66665 2.83334H3.24998C3.13947 2.83334 3.03349 2.87724 2.95535 2.95538C2.87721 3.03352 2.83331 3.1395 2.83331 3.25001V8.32168C2.83331 9.09834 3.26498 9.81001 3.95165 10.1683L8.66665 12.6283V2.83168V2.83334ZM30.75 2.83334H25.3333V12.63L30.0483 10.1667C30.3856 9.99038 30.6682 9.72506 30.8653 9.3995C31.0625 9.07395 31.1667 8.70061 31.1666 8.32001V3.25001C31.1666 3.1395 31.1227 3.03352 31.0446 2.95538C30.9665 2.87724 30.8605 2.83334 30.75 2.83334Z", fill: "white" })))),
        descriptionKey: 'REWARDS-description',
    },
    ASSET_MANAGEMENT: {
        icon: (React.createElement("span", { className: "anticon" },
            React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M20 40C8.954 40 0 31.046 0 20C0 8.954 8.954 0 20 0C31.046 0 40 8.954 40 20C40 31.046 31.046 40 20 40ZM20 36C24.2435 36 28.3131 34.3143 31.3137 31.3137C34.3143 28.3131 36 24.2435 36 20C36 15.7565 34.3143 11.6869 31.3137 8.68629C28.3131 5.68571 24.2435 4 20 4C15.7565 4 11.6869 5.68571 8.68629 8.68629C5.68571 11.6869 4 15.7565 4 20C4 24.2435 5.68571 28.3131 8.68629 31.3137C11.6869 34.3143 15.7565 36 20 36ZM20 10.1L29.9 20L20 29.9L10.1 20L20 10.1ZM20 15.758L15.758 20L20 24.242L24.242 20L20 15.758Z", fill: "white" })))),
        href: '/assets-app',
        descriptionKey: 'ASSET_MANAGEMENT-description',
    },
    ANALYTICS: {
        icon: React.createElement(LineChartOutlined, null),
        href: '/analytics-app',
        descriptionKey: 'ANALYTICS-description',
    },
    SMART_HUB: {
        icon: (React.createElement("span", { className: "anticon" },
            React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M20 40C8.954 40 0 31.046 0 20C0 8.954 8.954 0 20 0C31.046 0 40 8.954 40 20C40 31.046 31.046 40 20 40ZM20 36C24.2435 36 28.3131 34.3143 31.3137 31.3137C34.3143 28.3131 36 24.2435 36 20C36 15.7565 34.3143 11.6869 31.3137 8.68629C28.3131 5.68571 24.2435 4 20 4C15.7565 4 11.6869 5.68571 8.68629 8.68629C5.68571 11.6869 4 15.7565 4 20C4 24.2435 5.68571 28.3131 8.68629 31.3137C11.6869 34.3143 15.7565 36 20 36ZM20 10.1L29.9 20L20 29.9L10.1 20L20 10.1ZM20 15.758L15.758 20L20 24.242L24.242 20L20 15.758Z", fill: "white" })))),
        href: '/smart-hub-app',
        descriptionKey: 'SMART_HUB-description',
    },
    CLEARING: {
        icon: (React.createElement("span", { className: "anticon" },
            React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 70 67", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M12.3577 8.84562C18.599 3.51107 26.6566 0.570871 35 0.583537C53.8702 0.583537 69.1666 15.3203 69.1666 33.5002C69.1778 40.2281 67.0389 46.7961 63.0406 52.3121L53.7916 33.5002H62.3333C62.3334 28.2643 60.7134 23.1473 57.6802 18.8027C54.647 14.4582 50.3384 11.0834 45.3047 9.10947C40.271 7.13553 34.7408 6.65207 29.4206 7.72084C24.1003 8.78961 19.2315 11.3621 15.4361 15.1097L12.3611 8.84891L12.3577 8.84562ZM57.6422 58.1548C51.401 63.4893 43.3434 66.4295 35 66.4169C16.1297 66.4169 0.833313 51.6801 0.833313 33.5002C0.833313 26.5054 3.09856 20.0208 6.9594 14.6883L16.2083 33.5002H7.66665C7.66655 38.7361 9.28656 43.8531 12.3197 48.1977C15.3529 52.5422 19.6615 55.917 24.6952 57.8909C29.7289 59.8649 35.2591 60.3483 40.5794 59.2796C45.8997 58.2108 50.7685 55.6383 54.5638 51.8907L57.6388 58.1515L57.6422 58.1548ZM39.8311 42.809L30.1688 33.5002L20.5031 42.809L15.6719 38.1546L30.1688 24.1914L39.8311 33.5002L49.4969 24.1914L54.3281 28.8458L39.8311 42.809Z", fill: "white" })))),
        href: '/clearing-app',
        descriptionKey: 'CLEARING-description',
    },
};
var allModules = record.keys(applicationDefinitions);
var applicationEnv = {
    allowPersonal: true,
    login: undefined,
    password: undefined,
    activeModules: [
        'DASHBOARD',
        'BACKOFFICE',
        'MARKETPLACE',
        'PROSPERBILL',
        'WEB_WALLET',
        'ANALYTICS',
        'ASSET_MANAGEMENT',
        'REWARDS',
        'CLEARING',
    ],
    accountsPath: undefined,
};

var URI$2 = 'Result';
var ErrC = t.type({
    _tag: t.literal('Err'),
    _URI: t.literal(URI$2),
    value: t.any,
});
var Err = function (e) { return ({
    _tag: 'Err',
    _URI: URI$2,
    value: e,
}); };
var OkC = function (c) {
    return t.type({
        _tag: t.literal('Ok'),
        _URI: t.literal(URI$2),
        value: c,
    });
};
var Ok = function (x) { return ({
    _tag: 'Ok',
    _URI: URI$2,
    value: x,
}); };
var ResultC = function (c) { return t.union([ErrC, OkC(c)]); };
var getEq$2 = function (e) { return ({
    equals: function (a, b) {
        return a._tag === 'Ok' && b._tag === 'Ok'
            ? e.equals(a.value, b.value)
            : a._tag === b._tag;
    },
}); };
var ap$2 = function (fab, fa) {
    return fab._tag === 'Ok' ? (fa._tag === 'Ok' ? Ok(fab.value(fa.value)) : fa) : fab;
};
var map$2 = function (fa, fab) {
    return fa._tag === 'Ok' ? Ok(fab(fa.value)) : fa;
};
var of$2 = function (a) { return Ok(a); };
var chain$2 = function (fa, fab) {
    return fa._tag === 'Ok' ? fab(fa.value) : fa;
};
var isOk$1 = function (fa) { return fa._tag === 'Ok'; };
var isErr$1 = function (fa) { return fa._tag === 'Err'; };
var caseOf$1 = function (fa, cases) {
    return fa._tag === 'Ok' ? cases.Ok(fa.value) : cases.Err(fa.value);
};
var resultM = {
    URI: URI$2,
    of: of$2,
    ap: ap$2,
    map: map$2,
    chain: chain$2,
    caseOf: caseOf$1,
};
var getShow$1 = function (s) { return ({
    show: function (r) {
        return caseOf$1(r, {
            Ok: function (x) { return "Ok(" + s.show(x) + ")"; },
            Err: function (e) { return "Err(" + e + ")"; },
        });
    },
}); };
var result = __assign(__assign({}, pipeable(resultM)), { isErr: isErr$1,
    isOk: isOk$1,
    getEq: getEq$2,
    getShow: getShow$1, getOrElse: function (onNone) { return function (ma) {
        return resultM.caseOf(ma, { Ok: identity, Err: onNone });
    }; }, caseOf: function (cases) { return function (ma) {
        return resultM.caseOf(ma, cases);
    }; }, fromEither: function (e) {
        return either.fold(Err, Ok)(e);
    } });

var URI$1 = 'Loadable';
var NotRequestedC = t.type({
    _tag: t.literal('NotRequested'),
    _URI: t.literal(URI$1),
});
var NotRequested = {
    _tag: 'NotRequested',
    _URI: URI$1,
};
var LoadingC = t.type({
    _tag: t.literal('Loading'),
    _URI: t.literal(URI$1),
});
var Loading = { _tag: 'Loading', _URI: URI$1 };
var LoadableC = function (c) {
    return t.union([ResultC(c), LoadingC, NotRequestedC]);
};
var getEq$1 = function (e) { return ({
    equals: function (a, b) {
        return caseOf(a, {
            Ok: function (x) { return caseOf(b, { Ok: function (y) { return e.equals(x, y); }, _: function () { return false; } }); },
            Loading: function () { return b._tag === 'Loading'; },
            NotRequested: function () { return b._tag === 'NotRequested'; },
            Err: function () { return b._tag === 'Err'; },
        });
    },
}); };
var getShow = function (s) { return ({
    show: function (r) {
        return caseOf(r, {
            Ok: function (x) { return "Ok(" + s.show(x) + ")"; },
            Err: function (e) { return "Err(" + e + ")"; },
            Loading: function () { return 'Loading'; },
            NotRequested: function () { return 'NotRequested'; },
        });
    },
}); };
var getMonoid$1 = function (m) { return ({
    empty: NotRequested,
    concat: function (a, b) { return chain$1(a, function (a) { return map$1(b, function (b) { return m.concat(a, b); }); }); },
}); };
var ap$1 = function (fab, fa) {
    return fab._tag === 'Ok' ? (fa._tag === 'Ok' ? Ok(fab.value(fa.value)) : fa) : fab;
};
var map$1 = function (fa, fab) {
    return fa._tag === 'Ok' ? Ok(fab(fa.value)) : fa;
};
var of$1 = function (a) { return Ok(a); };
var chain$1 = function (fa, fab) { return (fa._tag === 'Ok' ? fab(fa.value) : fa); };
var caseOf = function (x, cases) {
    switch (x._tag) {
        case 'Ok':
            if (!!cases.Ok) {
                return cases.Ok(x.value);
            }
            break;
        case 'Err':
            if (!!cases.Err) {
                return cases.Err(x.value);
            }
            break;
        case 'Loading':
            if (!!cases.Loading) {
                return cases.Loading();
            }
            break;
        case 'NotRequested':
            if (!!cases.NotRequested) {
                return cases.NotRequested();
            }
            break;
    }
    if (!!cases._) {
        return cases._();
    }
    throw "no case match " + x._tag;
};
var isOk = function (fa) { return fa._tag === 'Ok'; };
var isErr = function (fa) { return fa._tag === 'Err'; };
var isLoading = function (fa) { return fa._tag === 'Loading'; };
var isNotRequested = function (fa) {
    return fa._tag === 'NotRequested';
};
var loadableM = {
    URI: URI$1,
    of: of$1,
    ap: ap$1,
    map: map$1,
    chain: chain$1,
    caseOf: caseOf,
};
var loadable = __assign(__assign({}, pipeable(loadableM)), { isOk: isOk,
    isErr: isErr,
    isLoading: isLoading,
    isNotRequested: isNotRequested,
    getEq: getEq$1,
    getShow: getShow,
    getMonoid: getMonoid$1,
    of: of$1, loadable: loadableM, getOrElse: function (onNone) { return function (ma) { return loadableM.caseOf(ma, { Ok: identity$1, _: onNone }); }; }, caseOf: function (cases) { return function (ma) {
        return loadableM.caseOf(ma, cases);
    }; }, toOption: function (ma) {
        return loadableM.caseOf(ma, { Ok: option.some, _: function () { return option.none; } });
    }, lookup: function (key) { return function (rec) {
        return LoadableC(t.any).is(rec)
            ? loadableM.chain(rec, function (rec) {
                return pipe(record.lookup(key, rec), option.fold(function () { return NotRequested; }, Ok));
            })
            : pipe(record.lookup(key, rec), option.getOrElse(function () { return NotRequested; }));
    }; } });

var URI = 'Memoed';
var MemoedC = function (c) {
    return t.type({
        _URI: t.literal(URI),
        v: LoadableC(c),
        memo: c,
    }, 'Memoed');
};
var getMonoid = function (m) {
    var lM = loadable.getMonoid(m);
    return {
        empty: init(m.empty),
        concat: function (a, b) { return from(m.concat(a.memo, b.memo))(lM.concat(a.v, b.v)); },
    };
};
var extract = function (a) { return loadable.getOrElse(function () { return a.memo; })(a.v); };
var ap = function (fab, fa) { return ({
    _URI: URI,
    v: loadable.ap(fa.v)(fab.v),
    memo: fab.memo(fa.memo),
}); };
var map = function (fa, fab) { return ({
    _URI: URI,
    v: loadable.map(fab)(fa.v),
    memo: fab(fa.memo),
}); };
var of = function (a) { return ({
    _URI: URI,
    memo: a,
    v: Ok(a),
}); };
var init = function (a) { return ({ _URI: URI, memo: a, v: NotRequested }); };
var from = function (d) { return function (a) { return step(a)(init(d)); }; };
var chain = function (fa, fab) { return ({
    _URI: URI,
    v: pipe$1(fa.v, loadable.chain(function (l) { return fab(l).v; })),
    memo: fab(extract(fa)).memo,
}); };
var step = function (next) { return function (fa) {
    var memo = pipe$1(next, loadable.getOrElse(function () { return fa.memo; }));
    return { memo: memo, _URI: URI, v: next };
}; };
var memoedM = {
    URI: URI,
    of: of,
    ap: ap,
    map: map,
    chain: chain,
};
var memoed = __assign(__assign({}, pipeable(memoedM)), { of: of,
    extract: extract,
    init: init,
    step: step,
    from: from,
    getMonoid: getMonoid, memoed: memoedM });

var Action = function (codec) { return t.interface({ type: codec }); };
var PayloadAction = function (typeCodec, payloadCodec) { return t.interface({ type: typeCodec, payload: payloadCodec }); };
var FailableAction = function (typeCodec, payloadCodec) { return PayloadAction(typeCodec, ResultC(payloadCodec)); };
var actionCreator = function (type) { return function () { return ({ type: type }); }; };
var payloadActionCreator = function (type) { return function (payload) { return ({ type: type, payload: payload }); }; };
var failableActionCreator = function (type) { return ({
    ok: function (payload) { return ({
        type: type,
        payload: Ok(payload),
    }); },
    err: function (err) { return ({
        type: type,
        payload: Err(err),
    }); },
}); };
var foldEitherToAction = function (actionCreator) { return function (e) {
    return pipe(e, either.fold(actionCreator.err, actionCreator.ok));
}; };
var noopAction = actionCreator('NOOP');

var DateString = new t.Type('DateString', function (u) { return u instanceof Date; }, function (u, c) {
    return pipe(t.string.validate(u, c), either.map(function (s) { return new Date(s); }), either.chain(function (d) { return (isNaN(d.getTime()) ? t.failure(u, c) : t.success(d)); }));
}, function (a) { return a.toISOString(); });

var protocolVersion = 'dcn1.0';
var SignatureInfo = t.type({
    signature: t.string,
    clauses: t.array(t.string),
});
var eqSignatureInfo = eq.struct({
    signature: string.Eq,
    clauses: array.getEq(string.Eq),
});
var Signatures = t.record(t.string, SignatureInfo, 'Signatures');
var eqSignatures = record.getEq(eqSignatureInfo);
var TransactionResult = t.type({
    success: t.boolean,
    error: optionFromNullable(t.string),
    uuid: t.string,
});
var eqTransactionResult = eq.struct({
    success: boolean.Eq,
    error: option.getEq(string.Eq),
    uuid: string.Eq,
});
var Balance$1 = t.record(t.string, t.number);
var eqBalance = record.getEq(number.Eq);
var compareBalances = function (a, b) {
    return allLess(a)(b) ? -1 : allLess(b)(a) ? 1 : 0;
};
/**
 * Ord instance for balance, a is inferior to b if and only if all amounts in a
 * are inferior to b
 */
var ordBalance = {
    equals: function (a, b) { return compareBalances(absBalance(a), absBalance(b)) === 0; },
    compare: compareBalances,
};
var getAmount = function (asset) { return function (a) {
    return pipe(record.lookup(asset, a), option.getOrElse(function () { return 0; }));
}; };
var allLess = function (a) { return function (b) {
    var balanceA = function (asset) { return getAmount(asset)(a); };
    return pipe(b, record.foldMapWithIndex(boolean.MonoidAll)(function (asset, amount) { return amount > balanceA(asset); }));
}; };
var anyLess = function (a) { return function (b) {
    var balanceA = function (asset) { return getAmount(asset)(a); };
    return pipe(b, record.foldMapWithIndex(boolean.MonoidAny)(function (asset, amount) { return amount > balanceA(asset); }));
}; };
var balanceSumMonoid = record.getMonoid(number.MonoidSum);
var Metadata = t.type({
    timestamp: t.string,
    location: t.string,
    message: t.string,
    terms: t.string,
    clientinfo: t.type({
        imei: optionFromNullable(t.string),
        ip: optionFromNullable(t.string),
        other: optionFromNullable(t.string),
    }),
    other: t.string,
    signatureinfo: SignatureInfo,
});
var emptyMetadata = {
    timestamp: '',
    location: '',
    message: '',
    terms: '',
    clientinfo: { imei: option.none, ip: option.none, other: option.none },
    other: '',
    signatureinfo: { signature: '', clauses: [] },
};
var eqMetadata = eq.struct({
    timestamp: string.Eq,
    location: string.Eq,
    message: string.Eq,
    terms: string.Eq,
    clientinfo: eq.struct({
        imei: option.getEq(string.Eq),
        ip: option.getEq(string.Eq),
        other: option.getEq(string.Eq),
    }),
    other: string.Eq,
    signatureinfo: eqSignatureInfo,
});
var Peer$1 = t.type({
    transferQuantity: Balance$1,
    transferSequence: optionFromNullable(t.number),
    metadata: optionFromNullable(Metadata),
}, 'Peer');
var eqPeer = eq.struct({
    transferQuantity: eqBalance,
    transferSequence: option.getEq(number.Eq),
    metadata: option.getEq(eqMetadata),
});
var Peers$2 = t.record(t.string, Peer$1, 'Peers');
var eqPeers = record.getEq(eqPeer);
var Transfer = t.type({
    type: t.literal('transfer'),
    protocolVersion: t.literal(protocolVersion),
    dcnNymID: t.string,
    signatures: Signatures,
    context: t.string,
    transactionResult: optionFromNullable(TransactionResult),
    peers: Peers$2,
}, 'Transfer');
var eqTransfer = eq.struct({
    type: string.Eq,
    protocolVersion: string.Eq,
    dcnNymID: string.Eq,
    signatures: eqSignatures,
    context: string.Eq,
    transactionResult: option.getEq(eqTransactionResult),
    peers: eqPeers,
});
var Bill = t.type({
    requesterID: t.string,
    amount: t.number,
    comment: t.string,
    asset: t.string,
    wallet: t.string,
    createdAt: DateString,
    updatedAt: DateString,
    status: t.keyof({
        /* eslint-disable @typescript-eslint/naming-convention */
        paid: null,
        pending_payment: null,
        pending_validation: null,
        /* eslint-enable @typescript-eslint/naming-convention */
    }),
    reference: t.string,
    requestURL: t.string,
}, 'Bill');
var EnrichedTransfer = t.type({
    transfer: Transfer,
    timestamp: DateString,
    status: t.keyof({
        pending: null,
        failed: null,
        success: null,
        cancelled: null,
    }),
    bill: optionFromNullable(Bill),
});
var eqEnrichedTransfer = eq.struct({
    transfer: eqTransfer,
    timestamp: date$2.Eq,
    status: string.Eq,
});
var enrichedTransferOrd = ord.contramap(function (t) { return t.timestamp; })(date$2.Ord);
var absBalance = record.map(Math.abs);
var ordPeerBalances = ord.contramap(function (p) {
    return absBalance(p.transferQuantity);
})(ordBalance);
var ordPeerBalancesWithPriority = function (nym) { return ({
    equals: function (a, b) { return ordPeerBalances.equals(a[1], b[1]); },
    compare: function (a, b) { return (a[0] === nym ? 1 : ordPeerBalances.compare(a[1], b[1])); },
}); };

var phoneRegex = /^(\+|00)[0-9]{1,3}[0-9]{8}$/;
var Phonenumber = new t.Type('Phonenumber', function (u) { return typeof u === 'string'; }, function (u, c) {
    return typeof u === 'string' && phoneRegex.test(u)
        ? t.success(u)
        : t.failure(u, c);
}, t.identity);
var cinRegex = /^[0-9]{9}$/;
var CIN = new t.Type('CIN', function (u) { return u instanceof Date; }, function (u, c) {
    return typeof u === 'string' && cinRegex.test(u) ? t.success(u) : t.failure(u, c);
}, t.identity);
var emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
var EmailAddress = new t.Type('Email', function (u) { return typeof u === 'string'; }, function (u, c) {
    return typeof u === 'string' && emailRegex.test(u)
        ? t.success(u)
        : t.failure(u, c);
}, t.identity);
var Profile = t.type({
    nym: t.string,
    firstName: optionFromNullable(t.string),
    lastName: optionFromNullable(t.string),
    phoneNumber: optionFromNullable(Phonenumber),
    emailAddress: optionFromNullable(EmailAddress),
    nickname: optionFromNullable(t.string),
    cin: optionFromNullable(t.string),
    scannedCin: optionFromNullable(t.string),
    facebook: optionFromNullable(t.string),
    gender: optionFromNullable(t.string),
    birthDate: optionFromNullable(t.string),
    governorate: optionFromNullable(t.string),
    cinRecto: optionFromNullable(t.string),
    cinVerso: optionFromNullable(t.string),
    userFace: optionFromNullable(t.string),
    profilePic: optionFromNullable(t.string),
    tradeName: optionFromNullable(t.string),
    crn: optionFromNullable(t.string),
    address: optionFromNullable(t.string),
    zipCode: optionFromNullable(t.string),
    androidVersion: optionFromNullable(t.string),
    operatorName: optionFromNullable(t.string),
    imei: optionFromNullable(t.string),
    deviceID: optionFromNullable(t.string),
    appCategory: optionFromNullable(t.string),
    patente: optionFromNullable(t.string),
    justificatifDeRevenue: optionFromNullable(t.string),
    accountType: optionFromNullable(t.string),
    description: optionFromNullable(t.string),
    createdAt: optionFromNullable(DateString),
});
var emptyProfile = {
    nym: '',
    firstName: option.none,
    lastName: option.none,
    phoneNumber: option.none,
    emailAddress: option.none,
    nickname: option.none,
    cin: option.none,
    scannedCin: option.none,
    facebook: option.none,
    gender: option.none,
    birthDate: option.none,
    governorate: option.none,
    cinRecto: option.none,
    cinVerso: option.none,
    userFace: option.none,
    profilePic: option.none,
    tradeName: option.none,
    crn: option.none,
    address: option.none,
    zipCode: option.none,
    androidVersion: option.none,
    operatorName: option.none,
    imei: option.none,
    deviceID: option.none,
    appCategory: option.none,
    patente: option.none,
    justificatifDeRevenue: option.none,
    accountType: option.none,
    description: option.none,
    createdAt: option.none,
};
var performIfNotRequested = function (p, a) {
    return pipe(p, option.fromPredicate(loadable.isNotRequested), option.map(io.of(a)), option.sequence(io.Applicative), io.map(constVoid));
};
var eqProfile = {
    equals: function (a, b) { return a.nym === b.nym; },
};
var contactQR = function (_a) {
    var nym = _a.nym, p = __rest(_a, ["nym"]);
    // TODO: get the base path from build config
    return pipe(sequenceT(option.Apply)(p.firstName, p.lastName), option.map(function (_a) {
        var firstName = _a[0], lastName = _a[1];
        return firstName + " " + lastName;
    }), option.alt(function () { return p.tradeName; }), option.getOrElse(function () { return 'unknown'; }), function (n) { return ({ n: n, nym: nym, v: '1', op: 'id' }); }, record.reduceWithIndex(new URL('/dcr/', 'https://dev.tpay.tn'), function (k, p, c) {
        p.searchParams.set(k, c);
        return p;
    }));
};

var UserState = t.type({
    nym: t.string,
    balance: Balance$1,
    transferSequences: t.array(t.tuple([t.number, t.number])),
});
var emptyUserState = {
    nym: '',
    balance: {},
    transferSequences: [],
};
var eqUserState = eq.getStructEq({
    nym: eq.eqString,
    balance: eqBalance,
    transferSequences: array.getEq(eq.getTupleEq(eq.eqNumber, eq.eqNumber)),
});

var getRecordKeys = function (r) {
    var res = [];
    for (var k in r) {
        // @ts-ignore
        res.push([k, r[k]]);
    }
    return res;
};

var AmountWithAssetName = t.type({
    amount: t.number,
    assetName: t.string,
    formatted: t.string,
}, 'BalanceDate');
var Balance = t.record(t.string, AmountWithAssetName, 'Balance');
var nullableString = withFallback(t.string, undefined);
var UserStateWithName = t.type({
    nym: withFallback(t.string, ''),
    firstName: nullableString,
    lastName: nullableString,
    accountType: nullableString,
    createdAt: withFallback(DateFromISOString, new Date(0)),
    balance: withFallback(Balance, {}),
}, 'UserStateWithName');
var nullableNumber = withFallback(t.number, undefined);
var Peer = t.type({
    fees: withFallback(Balance, {}),
    firstName: nullableString,
    lastName: nullableString,
    message: nullableString,
    transferQuantity: withFallback(Balance, {}),
    transferSequence: nullableNumber,
}, 'Peer');
var Peers$1 = t.record(t.string, Peer, 'Peers');
var TransactionStatus = t.keyof({
    Cancelled: null,
    Failed: null,
    Pending: null,
    Success: null,
}, 'TransactionStatus');
var TransactionType = t.keyof({
    Exchange: null,
    Incoming: null,
    Internal: null,
    Outgoing: null,
}, 'TransactionType');
var Transaction = t.type({
    context: withFallback(t.string, ''),
    totalAmount: withFallback(Balance, {}),
    feeAmount: withFallback(Balance, {}),
    netAmount: withFallback(Balance, {}),
    myPeers: withFallback(Peers$1, {}),
    otherPeers: withFallback(Peers$1, {}),
    status: withFallback(TransactionStatus, 'Pending'),
    timestamp: withFallback(DateFromISOString, new Date(0)),
    type: withFallback(TransactionType, 'Outgoing'),
    notarizationUUID: nullableString,
}, 'Transaction');
var SimpleUnit = t.type({
    issuerNymID: t.string,
    name: t.string,
    format: t.array(t.string),
    terms: t.string,
}, 'SimpleUnit');
var decimalPointsFromNumFormat = function (numFormat) {
    if (numFormat.indexOf('-0.') === 0) {
        return -(numFormat.length - 2);
    }
    else if (numFormat.indexOf('-1') === 0) {
        return numFormat.length - 2;
    }
    else {
        return 0;
    }
};
var parseFormat = function (format) {
    var _a = format.split(' '), numFormat = _a[0], code = _a[1];
    return {
        decimalPoints: decimalPointsFromNumFormat(numFormat !== null && numFormat !== void 0 ? numFormat : ''),
        code: code !== null && code !== void 0 ? code : '',
    };
};
var getParsedFormat = function (unit) {
    var fmt = unit.format[0];
    if (!fmt) {
        return { decimalPoints: 0, code: '' };
    }
    else {
        return parseFormat(fmt);
    }
};
var SimpleUnits = t.record(t.string, SimpleUnit, 'SimpleUnits');
var getUnitsAction = actionCreator('@react-tookit/get_units');
var getUnitsResult = failableActionCreator('@react-tookit/get_units_result');
var getNymIDAction = actionCreator('@react-tookit/get_nym_id');
var getNymIDResult = failableActionCreator('@react-tookit/get_nym_id_result');

var Authority = t.keyof({ ADMIN: null, USER: null });
var Permission = t.keyof({ CONTRIBUTOR: null, VIEWER: null });
var ModulePermissions = t.partial({
    DASHBOARD: Permission,
    BACKOFFICE: Permission,
    PROSPERBILL: Permission,
    WEB_WALLET: Permission,
    MARKETPLACE: Permission,
    ANALYTICS: Permission,
    REWARDS: Permission,
    ASSET_MANAGEMENT: Permission,
    SMART_HUB: Permission,
    CLEARING: Permission,
});
var hasRequiredModulePermissions = function (permissions) {
    return applicationEnv.activeModules === 'show all'
        ? true
        : applicationEnv.activeModules.some(function (m) { return !!permissions[m]; });
};
var WalletPermissions = t.record(t.string, Permission);
var AccountOrganizationInfo = t.type({
    name: t.string,
    permissions: ModulePermissions,
    authorities: Authority,
}, 'AccountOrganizationInfo ');
var UserBase = t.type({
    login: t.string,
    firstName: t.string,
    lastName: t.string,
    email: t.string,
    langKey: optionFromNullable(t.string),
    imageUrl: optionFromNullable(t.string),
    activated: t.boolean,
}, 'userBase');
var OrganizationUser = t.intersection([
    UserBase,
    t.type({
        jobTitle: optionFromNullable(t.string),
        modulePermissions: ModulePermissions,
        walletPermissions: WalletPermissions,
        authority: Authority,
    }),
], 'OrganizationUser');
var UAAAccount = t.intersection([
    UserBase,
    t.type({
        id: t.number,
        organizations: t.record(t.string, t.type({
            jobTitle: optionFromNullable(t.string),
            displayName: t.string,
            authority: Authority,
            modulePermissions: ModulePermissions,
            walletPermissions: t.record(t.string, Permission),
        })),
        tfaEnabled: t.boolean,
    }),
], 'Account');
var emptyAccount = {};

var getAccountAction = actionCreator('@react-toolkit/get_account');
var getAccountResultAction = failableActionCreator('@react-toolkit/get_account_result');
var logoutAction = actionCreator('@react-toolkit/logout');
var logoutResultAction = failableActionCreator('@react-toolkit/logout_result');

var getAccount = function (cancelToken) {
    return pipe(taskEither.tryCatch(function () { return axios.get('/uaa/api/account', { cancelToken: cancelToken }); }, function (err) { return err; }), task.map(either.chain(function (resp) { return UAAAccount.decode(resp.data); })));
};
var logout$2 = function (cancelToken) {
    return taskEither.tryCatch(function () { return axios.post('/auth/logout', {}, { cancelToken: cancelToken }); }, function (err) { return err; });
};

var Organization = t.type({
    id: withFallback(t.number, 0),
    bankName: withFallback(t.string, ''),
    url: withFallback(t.string, ''),
    logoUrl: withFallback(t.string, ''),
    iban: withFallback(t.string, ''),
    fiscalYear: withFallback(t.number, new Date().getFullYear()),
    fiscalId: withFallback(t.string, ''),
    name: withFallback(t.string, ''),
    displayName: withFallback(t.string, ''),
    rib: withFallback(t.string, ''),
    employeesNumber: withFallback(t.string, ''),
    activity: withFallback(t.string, ''),
    country: withFallback(t.string, ''),
    asset: withFallback(t.string, ''),
    email: withFallback(t.string, ''),
    users: withFallback(t.array(UAAAccount), []),
    modules: withFallback(t.array(Module), []),
}, 'Organization');
var emptyOrganization = {
    id: 0,
    bankName: '',
    url: '',
    logoUrl: '',
    iban: '',
    fiscalYear: new Date().getFullYear(),
    fiscalId: '',
    name: '',
    displayName: '',
    rib: '',
    employeesNumber: '',
    activity: '',
    country: '',
    asset: '',
    email: '',
    users: [],
    modules: [],
};

var openSelectWorkspaceModalAction = actionCreator('@react-toolkit/open_select_modal');
var selectOrganizationAction = payloadActionCreator('@react-toolkit/select_workspace');
var getCurrentWorkspaceAction = actionCreator('@react-toolkit/get_current_workspace');
var getCurrentWorkspaceResultAction = failableActionCreator('@react-toolkit/get_current_workspace_result');

function waitForWorkspace() {
    var org, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects.select(function (s) {
                    return s.prosperus.organization.currentWorkspace;
                })];
            case 1:
                org = _a.sent();
                if (loadable.isOk(org)) {
                    return [2 /*return*/, org.value];
                }
                _a.label = 2;
            case 2:
                return [4 /*yield*/, effects.take([
                        '@react-toolkit/get_current_workspace_result',
                    ])];
            case 3:
                action = _a.sent();
                if (loadable.isOk(action.payload)) {
                    return [2 /*return*/, action.payload.value];
                }
                return [3 /*break*/, 2];
            case 4: return [2 /*return*/];
        }
    });
}
function waitForAccount() {
    var account, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects.select(function (s) { return s.prosperus.account; })];
            case 1:
                account = _a.sent();
                if (loadable.isOk(account)) {
                    return [2 /*return*/, account.value];
                }
                _a.label = 2;
            case 2:
                return [4 /*yield*/, effects.take([
                        '@react-toolkit/get_account_result',
                    ])];
            case 3:
                action = _a.sent();
                if (loadable.isOk(action.payload)) {
                    return [2 /*return*/, action.payload.value];
                }
                return [3 /*break*/, 2];
            case 4: return [2 /*return*/];
        }
    });
}

var getOrganization = function (organizationName, cancelToken) {
    return pipe(taskEither.tryCatch(function () {
        return axios.get("/uaa/api/organizations/" + organizationName, {
            cancelToken: cancelToken,
        });
    }, function (err) { return err; }), task.map(either.chain(function (resp) { return Organization.decode(resp.data); })));
};

var hasOwnProperty = function (x, k) { return x.hasOwnProperty(k); };
var isCurrentWorkspace = function (v) {
    return typeof v === 'object' &&
        !!v &&
        hasOwnProperty(v, 'type') &&
        (v.type === 'personal' ||
            (hasOwnProperty(v, 'organization') && typeof v.organization === 'string'));
};
function getCurrentWorkspaceSaga(_) {
    var ws, account, organizations, cancelSource, putEffect, cancelled;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                ws = JSON.parse((_a = localStorage.getItem('currentWorkspace')) !== null && _a !== void 0 ? _a : '{}');
                if (!!isCurrentWorkspace(ws)) return [3 /*break*/, 8];
                return [4 /*yield*/, waitForAccount()];
            case 1:
                account = _b.sent();
                organizations = pipe(account.organizations, record.filter(function (org) {
                    return hasRequiredModulePermissions(org.modulePermissions);
                }), record.collect(function (name) { return ({
                    type: 'organization',
                    organization: name,
                }); }));
                if (!(organizations.length === 1 && !applicationEnv.allowPersonal)) return [3 /*break*/, 3];
                return [4 /*yield*/, effects.put(selectOrganizationAction(organizations[0]))];
            case 2:
                _b.sent();
                return [3 /*break*/, 7];
            case 3:
                if (!(organizations.length === 0 && applicationEnv.allowPersonal)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects.put(selectOrganizationAction({ type: 'personal' }))];
            case 4:
                _b.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, effects.put(openSelectWorkspaceModalAction())];
            case 6:
                _b.sent();
                _b.label = 7;
            case 7: return [2 /*return*/];
            case 8:
                if (!(ws.type === 'personal')) return [3 /*break*/, 10];
                return [4 /*yield*/, effects.put(getCurrentWorkspaceResultAction.ok(ws))];
            case 9:
                _b.sent();
                return [2 /*return*/];
            case 10:
                cancelSource = axios.CancelToken.source();
                _b.label = 11;
            case 11:
                _b.trys.push([11, , 14, 16]);
                return [4 /*yield*/, effects.call(pipe(getOrganization(ws.organization, cancelSource.token), taskEither.map(function (organization) { return ({
                        type: 'organization',
                        organization: organization,
                    }); }), task.map(foldEitherToAction(getCurrentWorkspaceResultAction)), task.map(function (a) { return effects.put(a); })))];
            case 12:
                putEffect = _b.sent();
                return [4 /*yield*/, putEffect];
            case 13:
                _b.sent();
                return [3 /*break*/, 16];
            case 14: return [4 /*yield*/, effects.cancelled()];
            case 15:
                cancelled = _b.sent();
                if (cancelled) {
                    cancelSource.cancel();
                }
                return [7 /*endfinally*/];
            case 16: return [2 /*return*/];
        }
    });
}
function selectOrganizationSaga(a) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                localStorage.setItem('currentWorkspace', JSON.stringify(a.payload));
                return [4 /*yield*/, effects.put(getCurrentWorkspaceAction())];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function saga$1() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects.all([
                    effects.takeLatest('@react-toolkit/select_workspace', selectOrganizationSaga),
                    effects.takeLatest('@react-toolkit/get_current_workspace', getCurrentWorkspaceSaga),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}

var initialState$1 = {
    currentWorkspace: NotRequested,
    selectModalActive: false,
};
var reducer$1 = function (s, a) {
    if (s === void 0) { s = initialState$1; }
    switch (a.type) {
        case '@react-toolkit/open_select_modal':
            return __assign(__assign({}, s), { selectModalActive: true });
        case '@react-toolkit/select_workspace':
            return __assign(__assign({}, s), { selectModalActive: false });
        case '@react-toolkit/get_current_workspace':
            return __assign(__assign({}, s), { currentWorkspace: Loading });
        case '@react-toolkit/get_current_workspace_result':
            return __assign(__assign({}, s), { currentWorkspace: a.payload });
        default:
            return s;
    }
};

function getAccountSaga(_) {
    var cancelSource, allEffect, cancelled;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                cancelSource = axios.CancelToken.source();
                _a.label = 1;
            case 1:
                _a.trys.push([1, , 4, 6]);
                return [4 /*yield*/, effects.call(pipe(getAccount(cancelSource.token), task.map(foldEitherToAction(getAccountResultAction)), task.map(function (a) {
                        return effects.all(a.payload._tag === 'Ok'
                            ? [
                                effects.put(a),
                                effects.put(getCurrentWorkspaceAction()),
                            ]
                            : [effects.put(a)]);
                    })))];
            case 2:
                allEffect = _a.sent();
                return [4 /*yield*/, allEffect];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, effects.cancelled()];
            case 5:
                cancelled = _a.sent();
                if (cancelled) {
                    cancelSource.cancel();
                }
                return [7 /*endfinally*/];
            case 6: return [2 /*return*/];
        }
    });
}
function logoutSaga(_) {
    var cancelSource, allEffect, cancelled;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                cancelSource = axios.CancelToken.source();
                _a.label = 1;
            case 1:
                _a.trys.push([1, , 4, 6]);
                return [4 /*yield*/, effects.call(pipe(logout$2(cancelSource.token), task.map(foldEitherToAction(logoutResultAction)), task.map(function (a) {
                        var cookies = ['access_token', 'session_token'];
                        cookies.forEach(function (c) {
                            document.cookie = c + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                        });
                        return effects.all([
                            effects.put(a),
                            effects.put(getAccountAction()),
                        ]);
                    })))];
            case 2:
                allEffect = _a.sent();
                return [4 /*yield*/, allEffect];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, effects.cancelled()];
            case 5:
                cancelled = _a.sent();
                if (cancelled) {
                    cancelSource.cancel();
                }
                return [7 /*endfinally*/];
            case 6: return [2 /*return*/];
        }
    });
}
function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects.all([
                    effects.takeLatest('@react-toolkit/get_account', getAccountSaga),
                    effects.takeLatest('@react-toolkit/logout', logoutSaga),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}

var initialState = NotRequested;
var reducer = function (s, a) {
    if (s === void 0) { s = initialState; }
    switch (a.type) {
        case '@react-toolkit/get_account':
            return Loading;
        case '@react-toolkit/get_account_result':
            return a.payload;
        case '@react-toolkit/logout':
            return Loading;
        case '@react-toolkit/logout_result':
            return NotRequested;
        default:
            return s;
    }
};

var useAccount = function () {
    return useSelector(function (s) { return option.toUndefined(loadable.toOption(s.prosperus.account)); });
};
var useCurrentWorkspace = function () {
    return useSelector(function (s) {
        return option.toUndefined(loadable.toOption(s.prosperus.organization.currentWorkspace));
    });
};
var useOrganization = function () {
    var ws = useCurrentWorkspace();
    return (ws === null || ws === void 0 ? void 0 : ws.type) === 'organization' ? ws.organization : undefined;
};
var useOrganizationPermissions = function () {
    return useSelector(function (s) {
        return pipe(loadable.toOption(s.prosperus.account), option.chain(function (account) {
            return pipe(loadable.toOption(s.prosperus.organization.currentWorkspace), option.filterMap(function (ws) {
                return ws.type === 'personal' ? option.none : option.some(ws.organization);
            }), option.chain(function (o) { return record.lookup(o.name, account.organizations); }));
        }), option.toUndefined);
    });
};
var useAvailableWorkspaces = function () {
    var _a;
    var loading = useSelector(function (s) {
        return s.prosperus.account._tag === 'Loading' ||
            s.prosperus.account._tag === 'NotRequested';
    });
    var account = useAccount();
    if (loading) {
        return 'Loading';
    }
    var orgs = pipe((_a = account === null || account === void 0 ? void 0 : account.organizations) !== null && _a !== void 0 ? _a : {}, record.filter(function (org) { return hasRequiredModulePermissions(org.modulePermissions); }), record.filterWithIndex(function (name, org) { return name !== 'PROSPERUS' || org.authority === 'ADMIN'; }), record.collect(function (name, org) { return ({
        type: 'organization',
        organization: __assign({ name: name }, org),
    }); }));
    return applicationEnv.allowPersonal ? __spreadArray([{ type: 'personal' }], orgs) : orgs;
};
var useAvatarURL = function () {
    var account = useAccount();
    return pipe(option.fromNullable(account), option.chain(function (a) { return a.imageUrl; }), option.map(function (url) {
        return url.indexOf('http') !== -1 ? url : "/images/uaa/" + url;
    }), option.toUndefined);
};
var useUnits = function () {
    var dispatch = useDispatch();
    var units = useSelector(function (s) { return s.prosperus.units; });
    React__default.useEffect(function () {
        if (loadable.isNotRequested(units)) {
            dispatch(getUnitsAction());
        }
    }, [units._tag]);
    return pipe(units, loadable.toOption, option.getOrElse(function () { return ({}); }));
};
var getDCNNym = function () {
    var dispatch = useDispatch();
    var dcnNymID = useSelector(function (s) { return s.prosperus.dcnNymID; });
    React__default.useEffect(function () {
        if (loadable.isNotRequested(dcnNymID)) {
            dispatch(getNymIDAction());
        }
    }, [dcnNymID._tag]);
    return pipe(dcnNymID, loadable.toOption, option.getOrElse(function () { return ''; }));
};

var noAuthority$1 = "No authorities";
var amount$1 = "Amount";
var personalAccount$1 = "Personal account";
var organizationAccount$1 = "{displayName} account";
var logout$1 = "Logout";
var companySettings$1 = "Organization settings";
var personalSettings$1 = "Personal settings";
var workspaces$1 = "Workspaces";
var modules$1 = "Modules";
var multipleAssets$1 = "Multiple assets";
var date$1 = "Date";
var type$1 = "Type";
var redirecting$1 = "Redirecting";
var wallet$1 = "Wallet";
var wallets$1 = "Wallets";
var noTransactions$1 = "No transactions";
var context$1 = "Context";
var notarizationID$1 = "Notarization ID";
var senders$1 = "Senders";
var messages$2 = "Messages";
var recipients$1 = "Recipients";
var amountSent$1 = "Amount sent";
var noSenders$1 = "No senders";
var noRecipients$1 = "No recipients";
var noMessages$1 = "No messages";
var noAmountSent$1 = "Amount sent is empty";
var noBalance$1 = "Balance is empty";
var status$1 = "Status";
var transactionStatus$1 = "Transaction status";
var totalAmount$1 = "Total amount";
var dcnNymID$1 = "DCN Nym ID";
var fees$1 = "Fees";
var noFees$1 = "No fees";
var noAmountReceived$1 = "Amount received is empty";
var netAmount$1 = "Net amount";
var feeAmount$1 = "Fee amount";
var amountReceived$1 = "Amount received";
var unitIDs$1 = "Asset IDs";
var multiplePeers$1 = "Multiple peers";
var peer$1 = "Peer";
var viewDetails$1 = "View details";
var subTransactions$1 = "Subtransactions";
var transactionReference$1 = "Transaction reference";
var cancel$1 = "Cancel";
var noWorkspaceOptions$1 = "No workspace options";
var clearFilters$1 = "Clear Filters";
var selectDate$1 = "Select date";
var after$1 = "After";
var before$1 = "Before";
var between$1 = "Between";
var amountPerAsset$1 = "Amount per asset";
var selectAsset$1 = "Select asset";
var asset$1 = "Asset";
var equalTo$1 = "Equal to";
var lessThan$1 = "Less than";
var moreThan$1 = "More than";
var amountFilterEqualTo$1 = "{code} equal to {amount}";
var amountFilterMoreThan$1 = "{code} more than {amount}";
var amountFilterLessThan$1 = "{code} less than {amount}";
var amountFilterBetween$1 = "{code} between {min} and {max}";
var selectNymPrompt$1 = "Select a wallet";
var searchFailed$1 = "Search failed";
var noResults$1 = "No results";
var DASHBOARD$1 = "Dashboard";
var BACKOFFICE$1 = "Back office";
var PROSPERBILL$1 = "Bills";
var WEB_WALLET$1 = "Web Wallet";
var MARKETPLACE$1 = "Marketplace";
var REWARDS$1 = "Rewards";
var ASSET_MANAGEMENT$1 = "Assets Management";
var ANALYTICS$1 = "Analytics";
var SMART_HUB$1 = "Smart Hub";
var CLEARING$1 = "Clearing";
var settings$1 = "Settings";
var modulesSettings$1 = "Modules Setting";
var english = {
	noAuthority: noAuthority$1,
	amount: amount$1,
	personalAccount: personalAccount$1,
	organizationAccount: organizationAccount$1,
	logout: logout$1,
	companySettings: companySettings$1,
	personalSettings: personalSettings$1,
	workspaces: workspaces$1,
	modules: modules$1,
	multipleAssets: multipleAssets$1,
	date: date$1,
	type: type$1,
	redirecting: redirecting$1,
	wallet: wallet$1,
	wallets: wallets$1,
	noTransactions: noTransactions$1,
	context: context$1,
	notarizationID: notarizationID$1,
	senders: senders$1,
	messages: messages$2,
	recipients: recipients$1,
	amountSent: amountSent$1,
	noSenders: noSenders$1,
	noRecipients: noRecipients$1,
	noMessages: noMessages$1,
	noAmountSent: noAmountSent$1,
	noBalance: noBalance$1,
	status: status$1,
	transactionStatus: transactionStatus$1,
	totalAmount: totalAmount$1,
	dcnNymID: dcnNymID$1,
	fees: fees$1,
	noFees: noFees$1,
	noAmountReceived: noAmountReceived$1,
	netAmount: netAmount$1,
	feeAmount: feeAmount$1,
	amountReceived: amountReceived$1,
	unitIDs: unitIDs$1,
	multiplePeers: multiplePeers$1,
	peer: peer$1,
	viewDetails: viewDetails$1,
	subTransactions: subTransactions$1,
	transactionReference: transactionReference$1,
	"export": "Export",
	cancel: cancel$1,
	noWorkspaceOptions: noWorkspaceOptions$1,
	clearFilters: clearFilters$1,
	selectDate: selectDate$1,
	after: after$1,
	before: before$1,
	between: between$1,
	amountPerAsset: amountPerAsset$1,
	selectAsset: selectAsset$1,
	asset: asset$1,
	equalTo: equalTo$1,
	lessThan: lessThan$1,
	moreThan: moreThan$1,
	amountFilterEqualTo: amountFilterEqualTo$1,
	amountFilterMoreThan: amountFilterMoreThan$1,
	amountFilterLessThan: amountFilterLessThan$1,
	amountFilterBetween: amountFilterBetween$1,
	"n/a": "N/A",
	selectNymPrompt: selectNymPrompt$1,
	searchFailed: searchFailed$1,
	noResults: noResults$1,
	"transactionType-Exchange": "Exchange",
	"transactionType-Incoming": "Incoming",
	"transactionType-Internal": "Internal",
	"transactionType-Outgoing": "Outgoing",
	"transactionStatus-Cancelled": "Cancelled",
	"transactionStatus-Failed": "Failed",
	"transactionStatus-Pending": "Pending",
	"transactionStatus-Success": "Success",
	DASHBOARD: DASHBOARD$1,
	BACKOFFICE: BACKOFFICE$1,
	PROSPERBILL: PROSPERBILL$1,
	WEB_WALLET: WEB_WALLET$1,
	MARKETPLACE: MARKETPLACE$1,
	REWARDS: REWARDS$1,
	ASSET_MANAGEMENT: ASSET_MANAGEMENT$1,
	ANALYTICS: ANALYTICS$1,
	SMART_HUB: SMART_HUB$1,
	CLEARING: CLEARING$1,
	"BACKOFFICE-description": "Manage assets, customers, policies and more",
	"DASHBOARD-description": "Monitor your transaction history and discover insights",
	"WEB_WALLET-description": "Use and create wallets to store your assets",
	"PROSPERBILL-description": "Build, collect & monitor receivables",
	"MARKETPLACE-description": "Create offers and trade your assets on the market",
	"REWARDS-description": "Set up and monitor rewards granted to your customers",
	"ASSET_MANAGEMENT-description": "Create and mint your organization's assets",
	"ANALYTICS-description": "Monitor your organization's transactions and asset and uncover insights",
	"SMART_HUB-description": "Invoice Financing Marketplace",
	"CLEARING-description": "Manage Clearing and Settlement using CBDC and Stable coins",
	settings: settings$1,
	modulesSettings: modulesSettings$1
};

var noAuthority = "Aucune autorité";
var amount = "Montant";
var personalAccount = "Compte personnel";
var organizationAccount = "Compte {displayName}";
var logout = "Déconnexion";
var companySettings = "Paramètres de l'organisation";
var personalSettings = "Paramètres personnels";
var workspaces = "Espaces de travail";
var multipleAssets = "Plusieurs actifs";
var date = "Date";
var type = "Type";
var redirecting = "Redirection en course";
var wallet = "Portefeuille";
var wallets = "Portefeuilles";
var noTransactions = "Aucune transaction";
var context = "Contexte";
var notarizationID = "ID de notarisation";
var senders = "Expéditeurs";
var messages$1 = "Messages";
var modules = "Modules";
var recipients = "Destinataires";
var amountSent = "Montant envoyé";
var noSenders = "Aucun expéditeur";
var noRecipients = "Aucun destinataire";
var noMessages = "Aucun message";
var noAmountSent = "Le montant envoyé est vide";
var noBalance = "Le solde est vide";
var status = "État";
var transactionStatus = "État de la transaction";
var totalAmount = "Montant total";
var dcnNymID = "Nym IP DCN";
var fees = "Frais";
var noFees = "Aucun frai";
var noAmountReceived = "Le montant reçu est vide";
var netAmount = "Montant net";
var feeAmount = "Montant des frais";
var amountReceived = "Montant reçu";
var unitIDs = "Identifiants d'actif";
var multiplePeers = "Plusieurs autres pariticipants";
var peer = "Pariticipant";
var viewDetails = "Afficher les détails";
var subTransactions = "Sous-transactions";
var transactionReference = "Référence de transaction";
var cancel = "Annuler";
var noWorkspaceOptions = "Aucun espace de travail";
var clearFilters = "Réinitialiser les filtres";
var selectDate = "Selectionner une date";
var after = "Après";
var before = "Avant";
var between = "Entre";
var amountPerAsset = "Montant par actif";
var selectAsset = "Selectionner un actif";
var asset = "Actif";
var equalTo = "Égal à";
var lessThan = "Inférieur à";
var moreThan = "Supérieur à";
var amountFilterEqualTo = "{code} égal à {amount}";
var amountFilterMoreThan = "{code} supérieur à {amount}";
var amountFilterLessThan = "{code} inférieur à {amount}";
var amountFilterBetween = "{code} entre {min} et {max}";
var selectNymPrompt = "Selectinner un portefeuille";
var searchFailed = "La recherche a échoué";
var noResults = "Aucun résultat";
var DASHBOARD = "Dashboard";
var BACKOFFICE = "Back office";
var PROSPERBILL = "Bills";
var WEB_WALLET = "Web Wallet";
var MARKETPLACE = "Marketplace";
var REWARDS = "Rewards";
var ASSET_MANAGEMENT = "Assets Management";
var ANALYTICS = "Analytics";
var SMART_HUB = "Smart Hub";
var CLEARING = "Clearing";
var settings = "Paramètres";
var modulesSettings = "Paramètres des modules";
var french = {
	noAuthority: noAuthority,
	amount: amount,
	personalAccount: personalAccount,
	organizationAccount: organizationAccount,
	logout: logout,
	companySettings: companySettings,
	personalSettings: personalSettings,
	workspaces: workspaces,
	multipleAssets: multipleAssets,
	date: date,
	type: type,
	redirecting: redirecting,
	wallet: wallet,
	wallets: wallets,
	noTransactions: noTransactions,
	context: context,
	notarizationID: notarizationID,
	senders: senders,
	messages: messages$1,
	modules: modules,
	recipients: recipients,
	amountSent: amountSent,
	noSenders: noSenders,
	noRecipients: noRecipients,
	noMessages: noMessages,
	noAmountSent: noAmountSent,
	noBalance: noBalance,
	status: status,
	transactionStatus: transactionStatus,
	totalAmount: totalAmount,
	dcnNymID: dcnNymID,
	fees: fees,
	noFees: noFees,
	noAmountReceived: noAmountReceived,
	netAmount: netAmount,
	feeAmount: feeAmount,
	amountReceived: amountReceived,
	unitIDs: unitIDs,
	multiplePeers: multiplePeers,
	peer: peer,
	viewDetails: viewDetails,
	subTransactions: subTransactions,
	transactionReference: transactionReference,
	"export": "Exporter",
	cancel: cancel,
	noWorkspaceOptions: noWorkspaceOptions,
	clearFilters: clearFilters,
	selectDate: selectDate,
	after: after,
	before: before,
	between: between,
	amountPerAsset: amountPerAsset,
	selectAsset: selectAsset,
	asset: asset,
	equalTo: equalTo,
	lessThan: lessThan,
	moreThan: moreThan,
	amountFilterEqualTo: amountFilterEqualTo,
	amountFilterMoreThan: amountFilterMoreThan,
	amountFilterLessThan: amountFilterLessThan,
	amountFilterBetween: amountFilterBetween,
	"n/a": "N/A",
	selectNymPrompt: selectNymPrompt,
	searchFailed: searchFailed,
	noResults: noResults,
	"transactionType-Exchange": "Échange",
	"transactionType-Incoming": "Entrant",
	"transactionType-Internal": "Interne",
	"transactionType-Outgoing": "Sortant",
	"transactionStatus-Cancelled": "Cancelled",
	"transactionStatus-Failed": "Annulé",
	"transactionStatus-Pending": "En attente",
	"transactionStatus-Success": "Succès",
	DASHBOARD: DASHBOARD,
	BACKOFFICE: BACKOFFICE,
	PROSPERBILL: PROSPERBILL,
	WEB_WALLET: WEB_WALLET,
	MARKETPLACE: MARKETPLACE,
	REWARDS: REWARDS,
	ASSET_MANAGEMENT: ASSET_MANAGEMENT,
	ANALYTICS: ANALYTICS,
	SMART_HUB: SMART_HUB,
	CLEARING: CLEARING,
	"BACKOFFICE-description": "Gérez les actifs, les clients, les politiques et plus encore",
	"DASHBOARD-description": "Surveillez votre historique de transactions et vos informations de découverte",
	"WEB_WALLET-description": "Utilisez et créez des portefeuilles pour stocker vos actifs",
	"PROSPERBILL-description": "Créer, collecter et suivre les créances",
	"MARKETPLACE-description": "Créez des offres et échangez vos actifs sur le marché",
	"REWARDS-description": "Configurez et suivez les récompenses accordées à vos clients",
	"ASSET_MANAGEMENT-description": "Créez et frappez les actifs de votre organisation",
	"ANALYTICS-description": "Surveillez les transactions et les actifs de votre organisation et découvrez des informations",
	"SMART_HUB-description": "Invoice Financing Marketplace",
	"CLEARING-description": "Gérez la compensation et le règlement à l'aide de la CBDC et des pièces stables",
	settings: settings,
	modulesSettings: modulesSettings
};

var messages = { en: english, fr: french };
var Locale = t.keyof(messages);
var locales = record.keys(messages);
var translatedMessage = function (locale) { return function (id) {
    return messages[locale][id];
}; };
var TranslatedMessage = function (p) { return React.createElement(FormattedMessage, __assign({}, p)); };
var localNames = {
    fr: 'Français',
    en: 'English',
};
var addMessages = function (ms) { return ({
    en: __assign(__assign({}, ms.en), messages.en),
    fr: __assign(__assign({}, ms.fr), messages.fr),
}); };

var workspaceMenuItemProps = function (dispatch, ws) {
    if (ws.type === 'personal') {
        return {
            icon: React.createElement(UserOutlined, null),
            onClick: function () {
                dispatch(selectOrganizationAction({ type: 'personal' }));
            },
            children: React.createElement(TranslatedMessage, { id: "personalAccount" }),
        };
    }
    return {
        icon: React.createElement(AppstoreOutlined, null),
        onClick: function () {
            return dispatch(selectOrganizationAction({
                type: 'organization',
                organization: ws.organization.name,
            }));
        },
        children: (React.createElement(TranslatedMessage, { id: "organizationAccount", values: ws.organization })),
    };
};
var WorkspacesSubMenu = function (_a) {
    var filterWorkspaces = _a.filterWorkspaces;
    var workspacesOrLoading = useAvailableWorkspaces();
    var dispatch = useDispatch();
    var workspaces = workspacesOrLoading === 'Loading' ? [] : workspacesOrLoading;
    if (workspaces.length <= 1) {
        return null;
    }
    var filteredWorkspaces = pipe(workspaces, array.filter(function (w) {
        return w.type === 'organization' ? filterWorkspaces(w.organization) : true;
    }));
    return (React.createElement(Menu.SubMenu, { key: "workspaces", title: React.createElement(TranslatedMessage, { id: "workspaces" }) }, filteredWorkspaces.map(function (ws) {
        var _a;
        return (React.createElement(Menu.Item, __assign({ key: (ws === null || ws === void 0 ? void 0 : ws.type) === 'personal' ? ws === null || ws === void 0 ? void 0 : ws.type : (_a = ws === null || ws === void 0 ? void 0 : ws.organization) === null || _a === void 0 ? void 0 : _a.name }, workspaceMenuItemProps(dispatch, ws))));
    })));
};

var SingleCharAvatar = styled.div(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  ", "\n  background: #cccccc;\n  color: #fff;\n"], ["\n  ",
    "\n  background: #cccccc;\n  color: #fff;\n"])), function (props) {
    var diameter = props.size === 'large' ? 64 : props.size === 'middle' ? 48 : 32;
    return css(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n      line-height: ", "px;\n      font-size: ", "px;\n      font-weight: 500;\n      text-align: center;\n      border-radius: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n      line-height: ", "px;\n      font-size: ", "px;\n      font-weight: 500;\n      text-align: center;\n      border-radius: ", "px;\n    "])), diameter, diameter, diameter, diameter / 2, diameter / 2);
});
var toAntdSize = function (size) {
    return size === 'large' ? 64 : size === 'middle' ? 48 : 32;
};
var MyAvatar = styled.div(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  background-image: url('", "');\n  background-position: center;\n  background-size: cover;\n  ", "\n"], ["\n  background-image: url('", "');\n  background-position: center;\n  background-size: cover;\n  ",
    "\n"])), function (props) { return props.src; }, function (props) {
    var diameter = props.size === 'large' ? 64 : props.size === 'middle' ? 48 : 32;
    return css(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n      line-height: ", "px;\n      font-size: ", "px;\n      font-weight: 500;\n      text-align: center;\n      border-radius: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n      line-height: ", "px;\n      font-size: ", "px;\n      font-weight: 500;\n      text-align: center;\n      border-radius: ", "px;\n    "])), diameter, diameter, diameter, diameter / 2, diameter / 2);
});
var HeaderIcon = function (_a) {
    var image = _a.image, _b = _a.size, size = _b === void 0 ? 'small' : _b, fallback = _a.fallback, text = _a.text;
    return !!image ? (React.createElement(MyAvatar, { size: size, src: image })) : !!text ? (React.createElement(SingleCharAvatar, { size: size }, text)) : (React.createElement(Avatar, { size: toAntdSize(size), icon: fallback }));
};
var UserIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'small' : _b;
    var avatarURL = useAvatarURL();
    var account = useAccount();
    return (React.createElement(HeaderIcon, { image: avatarURL, text: account === null || account === void 0 ? void 0 : account.login.substr(0, 2), fallback: React.createElement(UserOutlined, { style: {
                fontSize: size === 'large' ? '32px' : size === 'middle' ? '24px' : '16px',
            } }), size: size }));
};
var OrganizationIcon = function (_a) {
    _a.size;
    var ws = useCurrentWorkspace();
    var orgChars = (ws === null || ws === void 0 ? void 0 : ws.type) === 'organization'
        ? ws.organization.displayName.substr(0, 2)
        : undefined;
    return (ws === null || ws === void 0 ? void 0 : ws.type) === 'organization' ? (React.createElement(HeaderIcon, { image: "/images/uaa/" + ws.organization.logoUrl, fallback: React.createElement(BankOutlined, null), text: orgChars })) : null;
};
var templateObject_1$i, templateObject_2$a, templateObject_3$9, templateObject_4$3;

var MenuHeader = styled.div(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  & > span.ant-typography {\n    margin-top: 16px;\n    line-height: 24px;\n    height: 24px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  & > span.ant-typography {\n    margin-top: 16px;\n    line-height: 24px;\n    height: 24px;\n  }\n"])));
var MenuSpan = styled(Menu.Item)(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n  text-align: center;\n  ", "\n"], ["\n  text-align: center;\n  ",
    "\n"])), function (props) {
    return props.green
        ? css(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n          color: #51b148;\n        "], ["\n          color: #51b148;\n        "]))) : null;
});
var SubMenuSpan = styled(Menu.SubMenu)(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  text-align: center;\n  ", "\n"], ["\n  text-align: center;\n  ",
    "\n"])), function (props) {
    return props.green
        ? css(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n          color: #51b148;\n        "], ["\n          color: #51b148;\n        "]))) : null;
});
var AccountMenu = styled(Menu)(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  width: 400px;\n  padding: 16px;\n  box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12),\n    0px 6px 16px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05) !important;\n"], ["\n  width: 400px;\n  padding: 16px;\n  box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12),\n    0px 6px 16px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05) !important;\n"])));
var applications = pipe(applicationDefinitions, record.collect(function (name, def) { return (__assign(__assign({}, def), { name: name })); }));
var AccountSettingsDropDown$1 = function (_a) {
    var _b;
    var _c = _a.goToPersonalSettings, goToPersonalSettings = _c === void 0 ? function () {
        window.location.href = '/accounts/personal_setting';
    } : _c, _d = _a.goToOrganizationSettings, goToOrganizationSettings = _d === void 0 ? function () {
        window.location.href = '/accounts/organization_setting';
    } : _d, _e = _a.goToModulesSettings, goToModulesSettings = _e === void 0 ? function () {
        window.location.href = '/accounts/modules_setting/mint';
    } : _e, filterWorkspaces = _a.filterWorkspaces, extraModules = _a.extraModules, excludedModules = _a.excludedModules;
    var dispatch = useDispatch();
    var account = useAccount();
    var ws = useCurrentWorkspace();
    var organizationPermissions = useOrganizationPermissions();
    var isAdmin = (organizationPermissions === null || organizationPermissions === void 0 ? void 0 : organizationPermissions.authority) === 'ADMIN';
    var filteredApplications = pipe(applications, array.filter(function (app) {
        return excludedModules ? !excludedModules.includes(app.name) : true;
    }));
    var availableApplications = new Set((ws === null || ws === void 0 ? void 0 : ws.type) === 'personal'
        ? ['WEB_WALLET']
        : (ws === null || ws === void 0 ? void 0 : ws.type) === 'organization'
            ? record.keys(
            // Typescript does not see this as a Record<Module,unknown> which is
            // true but in this case this should not cause any problems.
            // @ts-ignore
            (_b = organizationPermissions === null || organizationPermissions === void 0 ? void 0 : organizationPermissions.modulePermissions) !== null && _b !== void 0 ? _b : {})
            : []);
    return (React.createElement(AccountMenu, null,
        React.createElement(Menu.Item, { key: 'main', style: { height: 'auto' } },
            React.createElement(MenuHeader, null,
                React.createElement(UserIcon, { size: "large" }),
                React.createElement(Typography.Text, { type: "secondary" }, account === null || account === void 0 ? void 0 : account.login),
                React.createElement(Typography.Text, { type: "secondary" }, account === null || account === void 0 ? void 0 : account.email))),
        React.createElement(Menu.SubMenu, { key: 'modules', title: React.createElement(TranslatedMessage, { id: "modules" }) },
            availableApplications.size === 0 ? (React.createElement(Menu.Item, null,
                React.createElement(Alert, { message: React.createElement(TranslatedMessage, { id: "noAuthority", defaultMessage: "Send" }), type: "warning" }))) : (filteredApplications
                .filter(function (app) { return availableApplications.has(app === null || app === void 0 ? void 0 : app.name); })
                .map(function (app) { return (React.createElement(Menu.Item, { key: app === null || app === void 0 ? void 0 : app.descriptionKey, onClick: function () {
                    window.location.href = app === null || app === void 0 ? void 0 : app.href;
                } },
                React.createElement(Row, { style: { width: '200px' }, align: "middle" },
                    React.createElement(Col, { flex: 2 },
                        React.createElement(Avatar, { icon: app === null || app === void 0 ? void 0 : app.icon })),
                    React.createElement(Col, null,
                        React.createElement("a", { href: app.href }),
                        (app === null || app === void 0 ? void 0 : app.name) ? React.createElement(TranslatedMessage, { id: app.name }) : null)))); })),
            extraModules),
        React.createElement(WorkspacesSubMenu, { filterWorkspaces: filterWorkspaces }),
        React.createElement(Divider, null),
        React.createElement(MenuSpan, { green: true, onClick: goToPersonalSettings },
            React.createElement(TranslatedMessage, { id: "personalSettings" })),
        isAdmin && (React.createElement(SubMenuSpan, { green: true, key: 'settings', title: React.createElement(TranslatedMessage, { id: "settings" }) },
            React.createElement(Menu.Item, { onClick: goToOrganizationSettings },
                React.createElement(TranslatedMessage, { id: "companySettings" })),
            React.createElement(Menu.Item, { onClick: goToModulesSettings },
                React.createElement(TranslatedMessage, { id: "modulesSettings" })))),
        React.createElement(MenuSpan, { danger: true, onClick: function () { return dispatch(logoutAction()); } },
            React.createElement(TranslatedMessage, { id: "logout" }))));
};
var templateObject_1$h, templateObject_2$9, templateObject_3$8, templateObject_4$2, templateObject_5$2, templateObject_6$1;

var AccountImages = styled.div(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  display: flex;\n  gap: 16px;\n  background: #fff;\n  padding: 2px;\n  border-radius: 19px;\n"], ["\n  display: flex;\n  gap: 16px;\n  background: #fff;\n  padding: 2px;\n  border-radius: 19px;\n"])));
var AccountSettingsDropDown = function (_a) {
    var goToPersonalSettings = _a.goToPersonalSettings, goToOrganizationSettings = _a.goToOrganizationSettings, goToModulesSettings = _a.goToModulesSettings, filterWorkspaces = _a.filterWorkspaces, extraModules = _a.extraModules, excludedModules = _a.excludedModules;
    return (React.createElement(Dropdown, { overlay: React.createElement(AccountSettingsDropDown$1, { goToPersonalSettings: goToPersonalSettings, goToOrganizationSettings: goToOrganizationSettings, goToModulesSettings: goToModulesSettings, filterWorkspaces: filterWorkspaces, extraModules: extraModules, excludedModules: excludedModules }), placement: "topCenter", arrow: true },
        React.createElement(AccountImages, null,
            React.createElement(OrganizationIcon, null),
            React.createElement(UserIcon, null))));
};
var templateObject_1$g;

var Logo = styled.div(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-start;\n  gap: 16px;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  gap: 16px;\n  align-items: center;\n"])));
var HeaderTitle = styled.div(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  color: #fff;\n  font-weight: 500;\n  font-size: 20px;\n"], ["\n  color: #fff;\n  font-weight: 500;\n  font-size: 20px;\n"])));
var HeaderStyled = styled(Layout$1.Header)(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n  position: sticky;\n  z-index: 99;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  position: sticky;\n  z-index: 99;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var Header = function (_a) {
    var children = _a.children, logo = _a.logo, goToPersonalSettings = _a.goToPersonalSettings, goToOrganizationSettings = _a.goToOrganizationSettings, goToModulesSettings = _a.goToModulesSettings, filterWorkspaces = _a.filterWorkspaces, extraModules = _a.extraModules, excludedModules = _a.excludedModules, customDropDown = _a.customDropDown;
    return (React.createElement(HeaderStyled, null,
        React.createElement(Link, { to: "/" }, typeof logo === 'string' ? (React.createElement(Logo, null,
            React.createElement(ProsperUSLogo, null),
            React.createElement(HeaderTitle, null, logo))) : !!logo ? (logo) : (React.createElement("img", { src: logo ? logo : img, alt: "LOGO", style: { height: '2rem', display: 'inherit' } }))),
        children,
        customDropDown ? (customDropDown) : (React.createElement(AccountSettingsDropDown, { goToPersonalSettings: goToPersonalSettings, goToOrganizationSettings: goToOrganizationSettings, goToModulesSettings: goToModulesSettings, filterWorkspaces: filterWorkspaces, extraModules: extraModules, excludedModules: excludedModules }))));
};
var templateObject_1$f, templateObject_2$8, templateObject_3$7;

var MenuWithTransitions = styled(Menu)(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  position: relative;\n  justify-content: center;\n  display: flex;\n  transition: ", ";\n  height: ", ";\n  overflow: hidden;\n"], ["\n  position: relative;\n  justify-content: center;\n  display: flex;\n  transition: ", ";\n  height: ", ";\n  overflow: hidden;\n"])), function (_a) {
    var $duration = _a.$duration;
    return " height " + $duration + "ms ease-in-out;";
}, function (_a) {
    var $visible = _a.$visible;
    return ($visible ? '46px' : 0);
});
var AnimatedMenu = function (_a) {
    var visible = _a.visible, duration = _a.duration, selectedKeys = _a.selectedKeys, onSelect = _a.onSelect, children = _a.children;
    return (React__default.createElement(MenuWithTransitions, { "$duration": duration, "$visible": visible, mode: "horizontal", disabledOverflow: true, selectedKeys: selectedKeys, onSelect: onSelect }, children));
};
var templateObject_1$e;

var CarouselInner = styled.div(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  padding-bottom: 24px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  padding-bottom: 24px;\n"])));
var CarouselScroller = styled.div(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  margin-left: 32px;\n  margin-right: 32px;\n  overflow: auto;\n  flex: 1;\n"], ["\n  margin-left: 32px;\n  margin-right: 32px;\n  overflow: auto;\n  flex: 1;\n"])));
var CarouselOuter = styled.div(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: stretch;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: stretch;\n"])));
var Carousel = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var children = _a.children;
    var outerRef = React.useRef(null);
    var onScroll = function () {
        return setScrollPosition(function (prev) {
            var _a, _b, _c, _d, _e, _f;
            return ({
                offsetWidth: (_b = (_a = outerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) !== null && _b !== void 0 ? _b : prev.offsetWidth,
                scrollWidth: (_d = (_c = outerRef.current) === null || _c === void 0 ? void 0 : _c.scrollWidth) !== null && _d !== void 0 ? _d : prev.scrollWidth,
                scrollLeft: (_f = (_e = outerRef.current) === null || _e === void 0 ? void 0 : _e.scrollLeft) !== null && _f !== void 0 ? _f : prev.scrollLeft,
            });
        });
    };
    var mutationObserver = React.useRef(new MutationObserver(function () {
        onScroll();
    }));
    var innerRef = React.useCallback(function (e) {
        if (!!e) {
            mutationObserver.current.observe(e, { childList: true });
        }
        else {
            mutationObserver.current.disconnect();
        }
    }, [mutationObserver.current]);
    var _h = React.useState({
        offsetWidth: (_c = (_b = outerRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) !== null && _c !== void 0 ? _c : 0,
        scrollWidth: (_e = (_d = outerRef.current) === null || _d === void 0 ? void 0 : _d.scrollWidth) !== null && _e !== void 0 ? _e : 0,
        scrollLeft: (_g = (_f = outerRef.current) === null || _f === void 0 ? void 0 : _f.scrollLeft) !== null && _g !== void 0 ? _g : 0,
    }), scrollPosition = _h[0], setScrollPosition = _h[1];
    var goLeft = function () { var _a; return (_a = outerRef.current) === null || _a === void 0 ? void 0 : _a.scrollBy({ left: -336 }); };
    var goRight = function () { var _a; return (_a = outerRef.current) === null || _a === void 0 ? void 0 : _a.scrollBy({ left: 336 }); };
    React.useEffect(function () {
        if (!!(outerRef === null || outerRef === void 0 ? void 0 : outerRef.current)) {
            var current_1 = outerRef.current;
            setScrollPosition({
                offsetWidth: current_1.offsetWidth,
                scrollWidth: current_1.scrollWidth,
                scrollLeft: current_1.scrollLeft,
            });
            current_1.addEventListener('scroll', onScroll);
            return function () { return current_1.removeEventListener('scroll', onScroll); };
        }
    }, [!!outerRef.current]);
    return (React.createElement(CarouselOuter, null,
        React.createElement(Button, { type: "primary", shape: "circle", disabled: scrollPosition.scrollLeft === 0, onClick: goLeft, icon: React.createElement(ArrowLeftOutlined, null) }),
        React.createElement(CarouselScroller, { ref: outerRef },
            React.createElement(CarouselInner, { ref: innerRef }, children)),
        React.createElement(Button, { type: "primary", shape: "circle", disabled: scrollPosition.scrollLeft + scrollPosition.offsetWidth >=
                scrollPosition.scrollWidth, onClick: goRight, icon: React.createElement(ArrowRightOutlined, null) })));
};
var templateObject_1$d, templateObject_2$7, templateObject_3$6;

var myDumbHashFunction = function (nym) {
    var s = 0;
    for (var i = 0; i < nym.length; i++) {
        s += nym.charCodeAt(i);
    }
    return s;
};
var colors = [
    "#20a527",
    "#1f2685",
    "#a94826",
    "#c8871f",
    "#942284",
    "#df67a0",
    "#028090",
    "#7c82ed",
    "#ff5e3b",
];
var getColor = function (nym) { return colors[myDumbHashFunction(nym) % colors.length]; };

var WithNym = styled.div(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  & .anticon {\n    margin-left: 0.46em;\n    color: #51b148;\n    font-size: 0.7em;\n  }\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  & .anticon {\n    margin-left: 0.46em;\n    color: #51b148;\n    font-size: 0.7em;\n  }\n"])));
var PeerWithNym = function (_a) {
    var firstName = _a.firstName, lastName = _a.lastName, nym = _a.nym, className = _a.className, _b = _a.popover, popover = _b === void 0 ? true : _b;
    var name = !!firstName || !!lastName ? ((firstName !== null && firstName !== void 0 ? firstName : '') + " " + (lastName !== null && lastName !== void 0 ? lastName : '')) : (React.createElement(TranslatedMessage, { id: "n/a" }));
    return (React.createElement(WithNym, { className: className },
        React.createElement("span", null,
            name,
            " "),
        popover && (React.createElement(Popover, { content: React.createElement(Typography.Text, { code: true, copyable: true }, nym) },
            React.createElement(InfoCircleOutlined, null)))));
};
var templateObject_1$c;

var BalanceCardS = styled(Card)(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: none;\n  min-width: 224px;\n  flex-basis: content;\n  flex-shrink: 0;\n  white-space: nowrap;\n  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.06);\n  & .border-top {\n    position: absolute;\n    width: 100%;\n    height: 8px;\n    background: ", ";\n    left: 0;\n    top: 0;\n  }\n  & .ant-card-head {\n    border-bottom: 1px solid #f0f0f0;\n    padding-left: 8px;\n    padding-right: 8px;\n    height: 70px;\n    font-size: 18px;\n    font-weight: 700;\n    color: rgba(0, 0, 0, 0.6);\n    & .ant-card-head-title {\n      display: flex;\n      gap: 8px;\n      height: 64px;\n      font-size: 18px;\n      line-height: 64px;\n      padding: 0;\n      margin-top: 8px;\n      align-items: center;\n    }\n  }\n  & .ant-card-body {\n    font-size: 30px;\n    font-weight: 700;\n    padding: 16px;\n    color: ", ";\n  }\n"], ["\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: none;\n  min-width: 224px;\n  flex-basis: content;\n  flex-shrink: 0;\n  white-space: nowrap;\n  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.06);\n  & .border-top {\n    position: absolute;\n    width: 100%;\n    height: 8px;\n    background: ", ";\n    left: 0;\n    top: 0;\n  }\n  & .ant-card-head {\n    border-bottom: 1px solid #f0f0f0;\n    padding-left: 8px;\n    padding-right: 8px;\n    height: 70px;\n    font-size: 18px;\n    font-weight: 700;\n    color: rgba(0, 0, 0, 0.6);\n    & .ant-card-head-title {\n      display: flex;\n      gap: 8px;\n      height: 64px;\n      font-size: 18px;\n      line-height: 64px;\n      padding: 0;\n      margin-top: 8px;\n      align-items: center;\n    }\n  }\n  & .ant-card-body {\n    font-size: 30px;\n    font-weight: 700;\n    padding: 16px;\n    color: ", ";\n  }\n"])), function (props) { return getColor(props.nym); }, function (props) { return getColor(props.nym); });
var AssetIcon = styled.div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  width: 48px;\n  height: 48px;\n  line-height: 44px;\n  border-radius: 24px;\n  background: rgba(0, 0, 0, 0.06);\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.06);\n  font-size: 24px;\n  font-weight: bold;\n  text-align: center;\n"], ["\n  width: 48px;\n  height: 48px;\n  line-height: 44px;\n  border-radius: 24px;\n  background: rgba(0, 0, 0, 0.06);\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.06);\n  font-size: 24px;\n  font-weight: bold;\n  text-align: center;\n"])));
var BalanceCard = function (_a) {
    var nym = _a.nym, amount = _a.amount;
    return (React.createElement(BalanceCardS, { nym: nym, title: React.createElement(React.Fragment, null,
            React.createElement(AssetIcon, null, amount.assetName[0]),
            amount.assetName) },
        React.createElement("div", { className: "border-top" }),
        amount.formatted));
};
var EmptyBalanceCard = function (_a) {
    var nym = _a.nym;
    return (React.createElement(BalanceCardS, { nym: nym },
        React.createElement("div", { className: "border-top" }),
        React.createElement(Empty, { description: React.createElement(TranslatedMessage, { id: "noBalance" }) })));
};
function isEmpty(r) {
    for (var _ in r) {
        return false;
    }
    return true;
}
var HeaderContainer$1 = styled.div(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var BalanceCarousel = function (_a) {
    var userState = _a.userState, _b = _a.loading, loading = _b === void 0 ? false : _b, headerExtra = _a.headerExtra;
    return (React.createElement(Card, { title: React.createElement(HeaderContainer$1, null,
            React.createElement(PeerWithNym, __assign({}, userState)),
            headerExtra) },
        React.createElement(Spin, { spinning: loading },
            React.createElement(Carousel, null, isEmpty(userState.balance) ? (React.createElement(EmptyBalanceCard, { nym: userState.nym })) : (pipe(userState.balance, record.collect(function (unitID, s) { return (React.createElement(BalanceCard, { nym: userState.nym, key: unitID, amount: s })); })))))));
};
var templateObject_1$b, templateObject_2$6, templateObject_3$5;

function getIfOne(vs) {
    if (vs.length === 1) {
        return vs[0];
    }
    return undefined;
}
var tagColors = {
    Success: 'green',
    Cancelled: 'default',
    Failed: 'red',
    Pending: 'orange',
};
var AmountCell = function (b) {
    var amount = pipe(b, record.collect(function (unitID, a) { return (__assign(__assign({}, a), { unitID: unitID })); }), getIfOne);
    return !!amount ? (React.createElement("span", null, amount.formatted)) : (React.createElement(TranslatedMessage, { id: "multipleAssets" }));
};
var walletColumns = {
    timestamp: {
        title: React.createElement(TranslatedMessage, { id: "date" }),
        key: 'date',
        dataIndex: 'timestamp',
        render: function (_, t) { return React.createElement(FormattedDate, { value: t.timestamp }); },
    },
    type: {
        title: React.createElement(TranslatedMessage, { id: "type" }),
        key: 'type',
        dataIndex: 'type',
        render: function (_, t) { return (React.createElement(TranslatedMessage, { id: "transactionType-" + t.type })); },
    },
    peer: {
        title: React.createElement(TranslatedMessage, { id: "peer" }),
        key: 'peer',
        dataIndex: 'peer',
        render: function (_, t) {
            var peer = pipe(t.otherPeers, record.collect(function (nym, p) { return (__assign(__assign({}, p), { nym: nym })); }), getIfOne);
            return !!peer ? (React.createElement(PeerWithNym, __assign({}, peer))) : (React.createElement(TranslatedMessage, { id: "multiplePeers" }));
        },
    },
    wallet: {
        title: React.createElement(TranslatedMessage, { id: "wallet" }),
        key: 'wallet',
        dataIndex: 'wallet',
        render: function (_, t) {
            var wallet = pipe(t.myPeers, record.collect(function (nym, p) { return (__assign(__assign({}, p), { nym: nym })); }), getIfOne);
            return !!wallet ? (React.createElement("span", null,
                wallet.firstName,
                " ",
                wallet.lastName,
                ' ')) : (React.createElement(TranslatedMessage, { id: "multiplePeers" }));
        },
    },
    feeAmount: {
        title: React.createElement(TranslatedMessage, { id: "fees" }),
        key: 'feeAmount',
        dataIndex: 'feeAmount',
        align: 'right',
        render: function (_, t) { return React.createElement(AmountCell, __assign({}, t.feeAmount)); },
    },
    netAmount: {
        title: React.createElement(TranslatedMessage, { id: "netAmount" }),
        key: 'netAmount',
        dataIndex: 'netAmount',
        align: 'right',
        render: function (_, t) { return React.createElement(AmountCell, __assign({}, t.netAmount)); },
    },
    totalAmount: {
        title: React.createElement(TranslatedMessage, { id: "totalAmount" }),
        key: 'totalAmount',
        dataIndex: 'totalAmount',
        align: 'right',
        render: function (_, t) { return React.createElement(AmountCell, __assign({}, t.totalAmount)); },
    },
    status: {
        title: React.createElement(TranslatedMessage, { id: "status" }),
        key: 'status',
        dataIndex: 'status',
        render: function (_, t) { return (React.createElement(Tag, { color: tagColors[t.status] },
            React.createElement(TranslatedMessage, { id: "transactionStatus-" + t.status }))); },
    },
};

var Title = styled.div(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  text-align: right;\n  font-weight: 700;\n"], ["\n  text-align: right;\n  font-weight: 700;\n"])));
var Field = function (_a) {
    var title = _a.title, content = _a.content;
    return (React.createElement(React.Fragment, null,
        React.createElement(Title, null,
            React.createElement(TranslatedMessage, { id: title })),
        React.createElement(Typography.Text, null, content)));
};
var Details = styled.div(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-column-gap: 32px;\n  align-items: center;\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-column-gap: 32px;\n  align-items: center;\n"])));
var isSender = function (p) {
    for (var unitID in p.transferQuantity) {
        if (p.transferQuantity[unitID].amount < 0) {
            return true;
        }
    }
    return false;
};
var NoBorderList = styled(List)(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  & .ant-list-item {\n    border: 0;\n    padding-left: 0px;\n    padding-right: 0px;\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n  & .ant-list-empty-text {\n    text-align: left;\n  }\n  & h4 {\n    font-size: 14px;\n    font-weight: 400;\n  }\n"], ["\n  & .ant-list-item {\n    border: 0;\n    padding-left: 0px;\n    padding-right: 0px;\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n  & .ant-list-empty-text {\n    text-align: left;\n  }\n  & h4 {\n    font-size: 14px;\n    font-weight: 400;\n  }\n"])));
var Peers = function (_a) {
    var transaction = _a.transaction, senders = _a.senders;
    return (React.createElement(NoBorderList, { bordered: false, size: "small", locale: {
            emptyText: senders ? (React.createElement(TranslatedMessage, { id: "noSenders" })) : (React.createElement(TranslatedMessage, { id: "noRecipients" })),
        }, dataSource: !!transaction
            ? pipe(__assign(__assign({}, transaction.myPeers), transaction.otherPeers), record.filter(function (p) { return (senders ? isSender(p) : !isSender(p)); }), record.collect(function (nym) { return nym; }))
            : [], renderItem: function (nym) { return (React.createElement(List.Item, { key: nym },
            React.createElement(Typography.Text, { code: true }, nym))); } }));
};
var hasMessage = function (p) { return !!p.message; };
var Messages = function (_a) {
    var transaction = _a.transaction;
    return (React.createElement(NoBorderList, { bordered: false, size: "small", locale: {
            emptyText: React.createElement(TranslatedMessage, { id: "noMessages" }),
        }, dataSource: !!transaction
            ? pipe(__assign(__assign({}, transaction.myPeers), transaction.otherPeers), record.filter(hasMessage), record.collect(function (nym, p) { return ({ nym: nym, message: p.message }); }))
            : [], renderItem: function (v) { return (React.createElement(List.Item, { key: v.nym },
            React.createElement(List.Item.Meta, { title: React.createElement(Typography.Text, { code: true }, v.nym), description: React.createElement(Typography.Text, null, v.message) }))); } }));
};
var BalanceList = styled(List)(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  & ul {\n    display: flex;\n    gap: 12px;\n    flex-wrap: wrap;\n    flex-direction: row;\n  }\n  & .ant-list-item {\n    border: 0;\n    padding-left: 0px;\n    padding-right: 0px;\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n  & .ant-list-empty-text {\n    text-align: left;\n  }\n  & h4 {\n    font-size: 14px;\n    font-weight: 400;\n  }\n"], ["\n  & ul {\n    display: flex;\n    gap: 12px;\n    flex-wrap: wrap;\n    flex-direction: row;\n  }\n  & .ant-list-item {\n    border: 0;\n    padding-left: 0px;\n    padding-right: 0px;\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n  & .ant-list-empty-text {\n    text-align: left;\n  }\n  & h4 {\n    font-size: 14px;\n    font-weight: 400;\n  }\n"])));
var BalanceCell = function (_a) {
    var balance = _a.balance, emptyText = _a.emptyText;
    return (React.createElement(BalanceList, { bordered: false, size: "small", locale: { emptyText: emptyText }, dataSource: !!balance
            ? pipe(balance, record.collect(function (unitID, a) { return ({ unitID: unitID, formatted: a.formatted }); }))
            : [], renderItem: function (v) { return React.createElement(List.Item, { key: v.unitID }, v.formatted); } }));
};
var UnitIDs = function (_a) {
    var transaction = _a.transaction;
    return (React.createElement(React.Fragment, null, !!transaction
        ? pipe(transaction.totalAmount, record.collect(function (unitID) { return (React.createElement(Typography.Text, { key: unitID, code: true },
            ' ',
            unitID,
            ' ')); }))
        : []));
};
var Seperator = styled.div(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  background: #f0f0f0;\n  grid-column: 1 / -1;\n  height: 1px;\n  margin-top: 4px;\n  margin-bottom: 8px;\n"], ["\n  background: #f0f0f0;\n  grid-column: 1 / -1;\n  height: 1px;\n  margin-top: 4px;\n  margin-bottom: 8px;\n"])));
var TransactionDetails = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.loading, loading = _f === void 0 ? false : _f, transaction = _a.transaction;
    var nymID = getDCNNym();
    return (React.createElement(Spin, { spinning: loading },
        React.createElement(Details, null,
            React.createElement(Field, { title: "context", content: transaction === null || transaction === void 0 ? void 0 : transaction.context }),
            React.createElement(Seperator, null),
            React.createElement(Field, { title: "notarizationID", content: transaction === null || transaction === void 0 ? void 0 : transaction.notarizationUUID }),
            React.createElement(Seperator, null),
            React.createElement(Field, { title: "senders", content: React.createElement(Peers, { senders: true, transaction: transaction }) }),
            React.createElement(Seperator, null),
            React.createElement(Field, { title: "messages", content: React.createElement(Messages, { transaction: transaction }) }),
            React.createElement(Seperator, null),
            React.createElement(Field, { title: "recipients", content: React.createElement(Peers, { senders: false, transaction: transaction }) }),
            React.createElement(Seperator, null),
            React.createElement(Field, { title: "amountSent", content: React.createElement(BalanceCell, { balance: transaction === null || transaction === void 0 ? void 0 : transaction.totalAmount, emptyText: React.createElement(TranslatedMessage, { id: "noAmountSent" }) }) }),
            React.createElement(Seperator, null),
            React.createElement(Field, { title: "amountReceived", content: React.createElement(BalanceCell, { balance: transaction === null || transaction === void 0 ? void 0 : transaction.netAmount, emptyText: React.createElement(TranslatedMessage, { id: "noAmountReceived" }) }) }),
            React.createElement(Seperator, null),
            React.createElement(Field, { title: "feeAmount", content: React.createElement(BalanceCell, { balance: transaction === null || transaction === void 0 ? void 0 : transaction.feeAmount, emptyText: React.createElement(TranslatedMessage, { id: "noFees" }) }) }),
            React.createElement(Seperator, null),
            React.createElement(Field, { title: "date", content: React.createElement(FormattedDate, { year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric", value: transaction === null || transaction === void 0 ? void 0 : transaction.timestamp }) }),
            React.createElement(Seperator, null),
            React.createElement(Field, { title: "dcnNymID", content: nymID }),
            React.createElement(Seperator, null),
            React.createElement(Field, { title: "unitIDs", content: React.createElement(UnitIDs, { transaction: transaction }) }),
            React.createElement(Seperator, null),
            React.createElement(Field, { title: "status", content: !!transaction
                    ? (_c = (_b = walletColumns.status).render) === null || _c === void 0 ? void 0 : _c.call(_b, {}, transaction, 0)
                    : undefined }),
            React.createElement(Seperator, null),
            React.createElement(Field, { title: "type", content: !!transaction
                    ? (_e = (_d = walletColumns.type).render) === null || _e === void 0 ? void 0 : _e.call(_d, {}, transaction, 0)
                    : undefined }))));
};
var templateObject_1$a, templateObject_2$5, templateObject_3$4, templateObject_4$1, templateObject_5$1;

var getTransactionPeers = function (transaction) {
    return pipe(__assign(__assign({}, transaction.myPeers), transaction.otherPeers), record.collect(function (nym, peer) { return (__assign({ nym: nym }, peer)); }), array.chain(function (p) {
        return pipe(p.transferQuantity, record.collect(function (unitID, a) {
            var _a;
            return ({
                unitID: unitID,
                nym: p.nym,
                firstName: p.firstName,
                lastName: p.lastName,
                key: p.nym + " " + unitID,
                type: a.amount < 0 ? 'Outgoing' : 'Incoming',
                timestamp: transaction.timestamp,
                amount: a.formatted,
                feeAmount: (_a = p.fees[unitID]) === null || _a === void 0 ? void 0 : _a.formatted,
                status: transaction.status,
            });
        }));
    }));
};
var columns$2 = [
    {
        title: React.createElement(TranslatedMessage, { id: "date" }),
        key: 'date',
        dataIndex: 'timestamp',
        render: function (_, t) { return React.createElement(FormattedDate, { value: t.timestamp }); },
    },
    {
        title: React.createElement(TranslatedMessage, { id: "type" }),
        key: 'type',
        dataIndex: 'type',
        render: function (_, t) { return (React.createElement(TranslatedMessage, { id: "transactionType-" + t.type })); },
    },
    {
        title: React.createElement(TranslatedMessage, { id: "peer" }),
        key: 'peer',
        dataIndex: 'peer',
        render: function (_, t) { return React.createElement(PeerWithNym, __assign({}, t)); },
    },
    {
        title: React.createElement(TranslatedMessage, { id: "amount" }),
        key: 'amount',
        dataIndex: 'amount',
        align: 'right',
        render: function (_, t) { return React.createElement("span", null, t.amount); },
    },
    {
        title: React.createElement(TranslatedMessage, { id: "feeAmount" }),
        key: 'feeAmount',
        dataIndex: 'feeAmount',
        align: 'right',
        render: function (_, t) { return React.createElement("span", null, t.feeAmount); },
    },
    {
        title: React.createElement(TranslatedMessage, { id: "status" }),
        key: 'status',
        dataIndex: 'status',
        render: function (_, t) { return (React.createElement(Tag, { color: tagColors[t.status] },
            React.createElement(TranslatedMessage, { id: "transactionStatus-" + t.status }))); },
    },
];
var Layout = styled.div(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  padding: 0 64px;\n"], ["\n  padding: 0 64px;\n"])));
var SubHeading = styled.div(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 22px;\n  padding-top: 16px;\n  padding-bottom: 8px;\n"], ["\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 22px;\n  padding-top: 16px;\n  padding-bottom: 8px;\n"])));
var Actions = styled.div(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  padding: 24px 0;\n  display: flex;\n  justify-content: center;\n"], ["\n  padding: 24px 0;\n  display: flex;\n  justify-content: center;\n"])));
var ExpandedTransactionRow = function (_a) {
    var transaction = _a.transaction, onExport = _a.onExport;
    var peers = getTransactionPeers(transaction);
    var _b = React.useState(false), modalVisible = _b[0], setModalVisible = _b[1];
    return (React.createElement(Layout, null,
        React.createElement(Modal, { title: React.createElement(TranslatedMessage, { id: "transactionReference", values: transaction }), visible: modalVisible, onCancel: function () { return setModalVisible(false); }, cancelText: React.createElement(TranslatedMessage, { id: "cancel" }), okText: React.createElement(TranslatedMessage, { id: "export" }), okButtonProps: { disabled: !onExport }, onOk: function () { return onExport === null || onExport === void 0 ? void 0 : onExport(transaction); } },
            React.createElement(TransactionDetails, { transaction: transaction })),
        React.createElement(SubHeading, null,
            React.createElement(TranslatedMessage, { id: "transactionReference" }),
            ": ",
            transaction.context),
        React.createElement(SubHeading, null,
            React.createElement(TranslatedMessage, { id: "subTransactions" }),
            ":"),
        React.createElement(Table, { dataSource: peers, columns: columns$2, pagination: false }),
        React.createElement(Actions, null,
            React.createElement(Button, { onClick: function () { return setModalVisible(true); } },
                React.createElement(TranslatedMessage, { id: "viewDetails" })))));
};
var templateObject_1$9, templateObject_2$4, templateObject_3$3;

var columns$1 = [
    walletColumns.timestamp,
    walletColumns.type,
    walletColumns.peer,
    walletColumns.totalAmount,
    walletColumns.wallet,
    walletColumns.status,
];
var OverviewTransactionTable = function (_a) {
    var transactions = _a.transactions, _b = _a.loading, loading = _b === void 0 ? false : _b;
    return (React.createElement(Table, { locale: {
            emptyText: React.createElement(TranslatedMessage, { id: "noTransactions" }),
        }, expandable: {}, size: "middle", dataSource: transactions.map(function (t) { return (__assign(__assign({}, t), { key: t.context })); }), columns: columns$1, pagination: false, loading: loading }));
};

var columns = [
    walletColumns.timestamp,
    walletColumns.type,
    walletColumns.peer,
    walletColumns.netAmount,
    walletColumns.feeAmount,
    walletColumns.totalAmount,
    walletColumns.status,
];
var TransactionsTable = function (_a) {
    var _b = _a.loading, loading = _b === void 0 ? false : _b, onExport = _a.onExport, transactions = _a.transactions, pagination = _a.pagination;
    return (React.createElement(Table, { columns: columns, dataSource: transactions.map(function (t) { return (__assign({ key: t.context }, t)); }), loading: loading, locale: {
            emptyText: (React.createElement(Empty, { description: React.createElement(TranslatedMessage, { id: "noTransactions" }) })),
        }, expandable: {
            expandedRowRender: function (t) { return React.createElement(ExpandedTransactionRow, { transaction: t, onExport: onExport }); },
        }, pagination: {
            current: pagination.page + 1,
            pageSize: pagination.itemsPerPage,
            onChange: function (p, ipp) {
                return pagination.onPaginate({
                    page: p - 1,
                    itemsPerPage: ipp !== null && ipp !== void 0 ? ipp : pagination.itemsPerPage,
                });
            },
            pageSizeOptions: ['10', '20', '50'],
            showSizeChanger: true,
            total: pagination.total,
        } }));
};

var StyledCard = styled(Card)(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  border-radius: 8px;\n  box-shadow: none;\n  border: 1px solid #f0f0f0;\n  white-space: nowrap;\n  flex-shrink: 0;\n  flex-basis: content;\n  min-width: 336px;\n  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.06);\n  & .ant-card-head {\n    height: 53px;\n    line-height: 53px;\n    padding: 0 24px;\n    background: ", ";\n    & .ant-card-head-title {\n      padding: 0;\n      color: #fff;\n      text-transform: uppercase;\n      font-weight: bold;\n      font-size: 18px;\n    }\n    & .anticon {\n      color: #fff;\n    }\n  }\n  & .ant-select {\n    width: 100%;\n  }\n  & .ant-card-body {\n    height: 158px;\n    padding: 24px;\n    display: flex;\n    flex-direction: column;\n    justify-content: stretch;\n  }\n"], ["\n  border-radius: 8px;\n  box-shadow: none;\n  border: 1px solid #f0f0f0;\n  white-space: nowrap;\n  flex-shrink: 0;\n  flex-basis: content;\n  min-width: 336px;\n  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.06);\n  & .ant-card-head {\n    height: 53px;\n    line-height: 53px;\n    padding: 0 24px;\n    background: ", ";\n    & .ant-card-head-title {\n      padding: 0;\n      color: #fff;\n      text-transform: uppercase;\n      font-weight: bold;\n      font-size: 18px;\n    }\n    & .anticon {\n      color: #fff;\n    }\n  }\n  & .ant-select {\n    width: 100%;\n  }\n  & .ant-card-body {\n    height: 158px;\n    padding: 24px;\n    display: flex;\n    flex-direction: column;\n    justify-content: stretch;\n  }\n"])), function (props) { return getColor(props.nym); });
var Amount = styled.div(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  flex: 1;\n  color: ", ";\n  font-size: 30px;\n  font-weight: 700;\n  padding-bottom: 16px;\n"], ["\n  flex: 1;\n  color: ", ";\n  font-size: 30px;\n  font-weight: 700;\n  padding-bottom: 16px;\n"])), function (props) { return getColor(props.nym); });
var ordBySymbol = pipe(string.Ord, ord.contramap(function (u) { return u.symbol; }));
var WalletBalanceCard = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var wallet = _a.wallet, pSelectedUnitID = _a.selectedUnitID, onSelectUnit = _a.onSelectUnit, units = _a.units;
    var walletBalance = pipe((_b = wallet.balance) !== null && _b !== void 0 ? _b : {}, record.toArray);
    var _h = React.useState((_c = walletBalance[0]) === null || _c === void 0 ? void 0 : _c[0]), selectedUnitID = _h[0], setSelectedUnitID = _h[1];
    var availableUnits = pipe(!!units
        ? pipe(units, record.collect(function (unitID, u) { return (__assign(__assign({}, u), { unitID: unitID })); }))
        : pipe((_d = wallet.balance) !== null && _d !== void 0 ? _d : {}, record.collect(function (unitID, a) {
            var _a, _b;
            return ({
                unitID: unitID,
                name: a.assetName,
                symbol: (_b = (_a = a.formatted.split(' ')) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : '',
            });
        })), array.sort(ordBySymbol));
    var selectedUnit = units === null || units === void 0 ? void 0 : units[selectedUnitID];
    React.useEffect(function () {
        if (!!pSelectedUnitID) {
            setSelectedUnitID(pSelectedUnitID);
        }
    }, [pSelectedUnitID]);
    var handleChange = function (value) {
        setSelectedUnitID(value);
        if (!!onSelectUnit) {
            onSelectUnit(value);
        }
    };
    return (React.createElement(StyledCard, { nym: wallet.nym, title: React.createElement(PeerWithNym, __assign({}, wallet)) },
        React.createElement(Amount, { nym: wallet.nym }, (_f = (_e = wallet.balance[selectedUnitID]) === null || _e === void 0 ? void 0 : _e.formatted) !== null && _f !== void 0 ? _f : "0 " + ((_g = selectedUnit === null || selectedUnit === void 0 ? void 0 : selectedUnit.symbol) !== null && _g !== void 0 ? _g : '')),
        React.createElement(Select, { value: selectedUnitID, onChange: handleChange }, availableUnits.map(function (u, index) { return (React.createElement(Select.Option, { key: index, value: u.unitID },
            React.createElement(Typography.Text, null,
                u.name,
                " (",
                u.symbol,
                ")"))); }))));
};
var templateObject_1$8, templateObject_2$3;

var HeaderContainer = styled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var WalletBalancesCarousel = function (_a) {
    var wallets = _a.wallets, _b = _a.loading, loading = _b === void 0 ? false : _b, headerExtra = _a.headerExtra;
    return (React.createElement(Card, { title: React.createElement(HeaderContainer, null,
            React.createElement(TranslatedMessage, { id: "wallets" }),
            headerExtra) },
        React.createElement(Spin, { spinning: loading },
            React.createElement(Carousel, null, pipe(wallets, record.collect(function (nym, s) { return React.createElement(WalletBalanceCard, { key: nym, wallet: s }); }))))));
};
var templateObject_1$7;

var getEq = function (e) {
    return pipe(option.getEq(e), eq.contramap(option.fromNullable));
};

var CloseIcon = function (_a) {
    var active = _a.active, onClick = _a.onClick, icon = _a.icon;
    return active ? (React.createElement(CloseCircleFilled, { onClick: function (e) {
            e.stopPropagation();
            onClick();
        } })) : (React.createElement(React.Fragment, null, icon));
};

var eqUndefinedFilter = getEq({
    equals: function (a, b) {
        if (a.unitID !== b.unitID) {
            return false;
        }
        else if (!a.type && !b.type) {
            return true;
        }
        else if (!a.type || !b.type) {
            return false;
        }
        else if (a.type === 'max' && b.type === 'max') {
            return a.max === b.max;
        }
        else if (a.type === 'min' && b.type === 'min') {
            return a.min === b.min;
        }
        else if (a.type === 'equal' && b.type === 'equal') {
            return a.equal === b.equal;
        }
        else if (a.type === 'minmax' && b.type === 'minmax') {
            return a.minValue === b.minValue && a.maxValue === b.maxValue;
        }
        else {
            return false;
        }
    },
});
var filterTypeFromProps = function (a) {
    return !!a.minAmount && !!a.maxAmount
        ? a.minAmount === a.maxAmount
            ? { type: 'equal', unitID: a.unitID, equal: a.minAmount }
            : {
                type: 'minmax',
                unitID: a.unitID,
                minValue: a.minAmount,
                maxValue: a.maxAmount,
            }
        : !!a.minAmount
            ? { type: 'min', unitID: a.unitID, min: a.minAmount }
            : !!a.maxAmount
                ? { type: 'max', unitID: a.unitID, max: a.maxAmount }
                : { unitID: a.unitID };
};
var propFromFilterType = function (a) {
    return a.type === 'minmax'
        ? { unitID: a.unitID, minAmount: a.minValue, maxAmount: a.maxValue }
        : a.type === 'equal'
            ? { unitID: a.unitID, minAmount: a.equal, maxAmount: a.equal }
            : a.type === 'min'
                ? { unitID: a.unitID, minAmount: a.min }
                : a.type === 'max'
                    ? { unitID: a.unitID, maxAmount: a.max }
                    : { unitID: a.unitID };
};
var SectionTitle = styled.div(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  size: 14px;\n"], ["\n  size: 14px;\n"])));
var Section = styled.div(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  min-width: 336px;\n  padding: 8px 12px;\n  & ", " {\n    margin-bottom: 10px;\n  }\n  & .ant-select {\n    width: calc(100% - 12px);\n    margin-left: 12px;\n  }\n"], ["\n  min-width: 336px;\n  padding: 8px 12px;\n  & ", " {\n    margin-bottom: 10px;\n  }\n  & .ant-select {\n    width: calc(100% - 12px);\n    margin-left: 12px;\n  }\n"])), SectionTitle);
var VerticalRadio = styled(Radio.Group)(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-row-gap: 10px;\n  grid-rows: 1 / 5;\n  & .ant-radio-wrapper {\n    height: 32px;\n    line-height: 32px;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-row-gap: 10px;\n  grid-rows: 1 / 5;\n  & .ant-radio-wrapper {\n    height: 32px;\n    line-height: 32px;\n  }\n"])));
var LayoutForm = styled(Form)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-column-gap: 8px;\n  grid-row-gap: 10px;\n  & .ant-form-item {\n    margin-bottom: 0 !important;\n  }\n  & > *:first-child {\n    grid-row: 1 / 5;\n  }\n  & .ant-form-item-control-input-content {\n    display: flex;\n  }\n  & .ant-input-number {\n    flex: 1;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-column-gap: 8px;\n  grid-row-gap: 10px;\n  & .ant-form-item {\n    margin-bottom: 0 !important;\n  }\n  & > *:first-child {\n    grid-row: 1 / 5;\n  }\n  & .ant-form-item-control-input-content {\n    display: flex;\n  }\n  & .ant-input-number {\n    flex: 1;\n  }\n"])));
var DoubleInput = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: stretch;\n  align-items: center;\n  gap: 8px;\n  & > .ant-input-number {\n    flex: 1;\n  }\n  & > div {\n    flex: 0;\n    font-size: 14px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: stretch;\n  align-items: center;\n  gap: 8px;\n  & > .ant-input-number {\n    flex: 1;\n  }\n  & > div {\n    flex: 0;\n    font-size: 14px;\n  }\n"])));
var DrowdownButton = styled(Button)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  padding-left: 12px;\n  padding-right: 12px;\n  ", "\n  & .anticon {\n    margin-left: 9px;\n  }\n"], ["\n  padding-left: 12px;\n  padding-right: 12px;\n  ",
    "\n  & .anticon {\n    margin-left: 9px;\n  }\n"])), function (props) {
    return !props.active
        ? css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n          color: #d0d0d0;\n        "], ["\n          color: #d0d0d0;\n        "]))) : null;
});
var multUndefined = function (a, b) {
    return !!a && !!b ? Math.floor(a * b) : undefined;
};
var divUndefined = function (a, b) {
    return !!a && !!b ? a / b : undefined;
};
var AmountFilter = function (_a) {
    var _b;
    var units = _a.units, value = _a.value, onChange = _a.onChange;
    var dispatch = useDispatch();
    var stateUnits = useSelector(function (s) { return s.prosperus.units; });
    var _c = React.useState(false), visible = _c[0], setVisible = _c[1];
    var _d = React.useState(!!units ? Ok(units) : stateUnits), loadableUnits = _d[0], setLoadableUnits = _d[1];
    var _e = React.useState(), filter = _e[0], setFilter = _e[1];
    var ref = React.useRef(0);
    ref.current = 3;
    // Set units from state if none are passed in props
    React.useEffect(function () {
        if (!units) {
            setLoadableUnits(stateUnits);
        }
    }, [stateUnits._tag]);
    // Set units from props
    React.useEffect(function () {
        if (!!units) {
            setLoadableUnits(Ok(units));
        }
    }, [units]);
    // Dispatch getUnitsAction when units are not loaded
    React.useEffect(function () {
        if (loadable.isNotRequested(loadableUnits)) {
            dispatch(getUnitsAction());
        }
    }, [loadable.isNotRequested(loadableUnits)]);
    // Update filter in state from props
    React.useEffect(function () {
        if (((filter === null || filter === void 0 ? void 0 : filter.type) === 'equal' && filter.equal === undefined) ||
            ((filter === null || filter === void 0 ? void 0 : filter.type) === 'min' && filter.min === undefined) ||
            ((filter === null || filter === void 0 ? void 0 : filter.type) === 'max' && filter.max === undefined) ||
            ((filter === null || filter === void 0 ? void 0 : filter.type) === 'minmax' &&
                filter.minValue === undefined &&
                filter.maxValue === undefined)) {
            return;
        }
        var newFilter = !!value ? filterTypeFromProps(value) : undefined;
        if (!eqUndefinedFilter.equals(filter, newFilter)) {
            setFilter(function (fs) {
                return (fs === null || fs === void 0 ? void 0 : fs.type) === 'minmax' && (newFilter === null || newFilter === void 0 ? void 0 : newFilter.type) === 'max' && !!newFilter.max
                    ? __assign(__assign({}, fs), { maxVale: newFilter.max }) : (fs === null || fs === void 0 ? void 0 : fs.type) === 'minmax' &&
                    (newFilter === null || newFilter === void 0 ? void 0 : newFilter.type) === 'min' &&
                    !!newFilter.min
                    ? __assign(__assign({}, fs), { minValue: newFilter.min }) : newFilter;
            });
        }
    }, [value === null || value === void 0 ? void 0 : value.unitID, value === null || value === void 0 ? void 0 : value.maxAmount, value === null || value === void 0 ? void 0 : value.minAmount]);
    // Update callback from state
    React.useEffect(function () {
        if (!onChange) {
            return;
        }
        var newProp = !!filter ? propFromFilterType(filter) : undefined;
        console.log('new props', filter, newProp);
        if ((newProp === null || newProp === void 0 ? void 0 : newProp.unitID) !== (value === null || value === void 0 ? void 0 : value.unitID) ||
            (newProp === null || newProp === void 0 ? void 0 : newProp.minAmount) !== (value === null || value === void 0 ? void 0 : value.minAmount) ||
            (newProp === null || newProp === void 0 ? void 0 : newProp.maxAmount) !== (value === null || value === void 0 ? void 0 : value.maxAmount)) {
            console.log('on change', newProp);
            onChange(newProp);
        }
    }, [filter]);
    var format = pipe(loadableUnits, loadable.toOption, option.chain(record.lookup((_b = filter === null || filter === void 0 ? void 0 : filter.unitID) !== null && _b !== void 0 ? _b : '')), option.map(getParsedFormat), option.toUndefined);
    var step = !!format ? Math.pow(10, -format.decimalPoints) : undefined;
    var multiplier = !!format ? Math.pow(10, format.decimalPoints) : 1;
    var form = Form.useForm()[0];
    React.useEffect(function () {
        form.resetFields();
    }, [visible]);
    var active = ((filter === null || filter === void 0 ? void 0 : filter.type) === 'equal' && !!filter.equal) ||
        ((filter === null || filter === void 0 ? void 0 : filter.type) === 'max' && !!filter.max) ||
        ((filter === null || filter === void 0 ? void 0 : filter.type) === 'min' && !!filter.min) ||
        ((filter === null || filter === void 0 ? void 0 : filter.type) === 'minmax' && !!filter.minValue && !!filter.maxValue);
    return (React.createElement(Dropdown, { trigger: ['click'], visible: visible, overlay: React.createElement(Card, { onMouseLeave: function () { return setVisible(false); } },
            React.createElement(Section, null,
                React.createElement(SectionTitle, null,
                    React.createElement(TranslatedMessage, { id: "asset" })),
                React.createElement(Select, { loading: loadable.isLoading(loadableUnits), value: filter === null || filter === void 0 ? void 0 : filter.unitID, placeholder: React.createElement(TranslatedMessage, { id: "selectAsset" }), onSelect: function (unitID) { return setFilter(function (fs) { return (__assign(__assign({}, fs), { unitID: unitID })); }); } }, pipe(loadableUnits, loadable.toOption, option.getOrElse(function () { return ({}); }), record.collect(function (unitID, unit) { return (React.createElement(Select.Option, { value: unitID, key: unitID }, unit.name)); })))),
            React.createElement(Section, null,
                React.createElement(SectionTitle, null,
                    React.createElement(TranslatedMessage, { id: "amount" })),
                React.createElement(LayoutForm, { form: form, initialValues: __assign(__assign({}, filter), { 
                        // @ts-ignore
                        min: divUndefined(filter === null || filter === void 0 ? void 0 : filter.min, multiplier), 
                        // @ts-ignore
                        max: divUndefined(filter === null || filter === void 0 ? void 0 : filter.max, multiplier), 
                        // @ts-ignore
                        minValue: divUndefined(filter === null || filter === void 0 ? void 0 : filter.minValue, multiplier), 
                        // @ts-ignore
                        maxValue: divUndefined(filter === null || filter === void 0 ? void 0 : filter.maxValue, multiplier), 
                        // @ts-ignore
                        equal: divUndefined(filter === null || filter === void 0 ? void 0 : filter.equal, multiplier) }), onValuesChange: function (_, v) {
                        // @ts-ignore
                        console.log('form', v, multiplier, v.min, v.min * multiplier);
                        // @ts-ignore
                        setFilter(function (fs) { return (__assign(__assign({ unitID: fs === null || fs === void 0 ? void 0 : fs.unitID }, v), { 
                            // @ts-ignore
                            min: multUndefined(v.min, multiplier), 
                            // @ts-ignore
                            max: multUndefined(v.max, multiplier), 
                            // @ts-ignore
                            minValue: multUndefined(v.minValue, multiplier), 
                            // @ts-ignore
                            maxValue: multUndefined(v.maxValue, multiplier), 
                            // @ts-ignore
                            equal: multUndefined(v.equal, multiplier) })); });
                    } },
                    React.createElement(Form.Item, { name: "type" },
                        React.createElement(VerticalRadio, null,
                            React.createElement(Radio, { disabled: !format, value: "equal" },
                                React.createElement(TranslatedMessage, { id: "equalTo" })),
                            React.createElement(Radio, { disabled: !format, value: "max" },
                                React.createElement(TranslatedMessage, { id: "lessThan" })),
                            React.createElement(Radio, { disabled: !format, value: "min" },
                                React.createElement(TranslatedMessage, { id: "moreThan" })),
                            React.createElement(Radio, { disabled: !format, value: "minmax" },
                                React.createElement(TranslatedMessage, { id: "between" })))),
                    React.createElement(Form.Item, { name: "equal" },
                        React.createElement(InputNumber, { disabled: (filter === null || filter === void 0 ? void 0 : filter.type) !== 'equal', step: step })),
                    React.createElement(Form.Item, { name: "max" },
                        React.createElement(InputNumber, { disabled: (filter === null || filter === void 0 ? void 0 : filter.type) !== 'max', step: step })),
                    React.createElement(Form.Item, { name: "min" },
                        React.createElement(InputNumber, { disabled: (filter === null || filter === void 0 ? void 0 : filter.type) !== 'min', step: step })),
                    React.createElement(DoubleInput, null,
                        React.createElement(Form.Item, { name: "minValue" },
                            React.createElement(InputNumber, { disabled: (filter === null || filter === void 0 ? void 0 : filter.type) !== 'minmax', step: step })),
                        React.createElement("div", null, "-"),
                        React.createElement(Form.Item, { name: "maxValue" },
                            React.createElement(InputNumber, { disabled: (filter === null || filter === void 0 ? void 0 : filter.type) !== 'minmax', step: step })))))) },
        React.createElement(DrowdownButton, { onClick: function () { return setVisible(function (v) { return !v; }); }, active: active },
            (filter === null || filter === void 0 ? void 0 : filter.type) === 'equal' && !!filter.equal ? (React.createElement(TranslatedMessage, { id: "amountFilterEqualTo", values: {
                    amount: filter.equal / multiplier,
                    code: format === null || format === void 0 ? void 0 : format.code,
                } })) : (filter === null || filter === void 0 ? void 0 : filter.type) === 'max' && !!filter.max ? (React.createElement(TranslatedMessage, { id: "amountFilterLessThan", values: {
                    amount: filter.max / multiplier,
                    code: format === null || format === void 0 ? void 0 : format.code,
                } })) : (filter === null || filter === void 0 ? void 0 : filter.type) === 'min' && !!filter.min ? (React.createElement(TranslatedMessage, { id: "amountFilterMoreThan", values: {
                    amount: filter.min / multiplier,
                    code: format === null || format === void 0 ? void 0 : format.code,
                } })) : (filter === null || filter === void 0 ? void 0 : filter.type) === 'minmax' &&
                !!filter.minValue &&
                !!filter.maxValue ? (React.createElement(TranslatedMessage, { id: "amountFilterBetween", values: {
                    min: filter.minValue / multiplier,
                    max: filter.maxValue / multiplier,
                    code: format === null || format === void 0 ? void 0 : format.code,
                } })) : (React.createElement(TranslatedMessage, { id: "amountPerAsset" })),
            React.createElement(CloseIcon, { onClick: function () { return setFilter({}); }, active: active, icon: React.createElement(DownOutlined, null) }))));
};
var AmountFilter$1 = React.memo(AmountFilter, function () { return false; });
var templateObject_1$6, templateObject_2$2, templateObject_3$2, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

var eqByDate = {
    equals: function (a, b) {
        return a.getDate() === b.getDate() &&
            a.getMonth() === b.getMonth() &&
            a.getFullYear() === b.getFullYear();
    },
};
var eqUndefinedByDate = getEq(eqByDate);
var CalendarButton = styled(Button)(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  min-width: 164px;\n  ", "\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  min-width: 164px;\n  ",
    "\n"])), function (props) {
    return !props.active
        ? css(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n          color: #d0d0d0;\n        "], ["\n          color: #d0d0d0;\n        "]))) : null;
});
var Grid = styled(Radio.Group)(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-column-gap: 8px;\n  grid-row-gap: 10px;\n  padding: 8px 12px;\n"], ["\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-column-gap: 8px;\n  grid-row-gap: 10px;\n  padding: 8px 12px;\n"])));
var eqDateFilterValue = {
    equals: function (a, b) {
        var _a, _b, _c, _d;
        if ((a.type === 'date' && b.type === 'date') ||
            (a.type === 'before' && b.type === 'before') ||
            (a.type === 'after' && b.type === 'after')) {
            return eqUndefinedByDate.equals(a.value, b.value);
        }
        else if (a.type === 'between' && b.type === 'between') {
            return (eqUndefinedByDate.equals((_a = a.value) === null || _a === void 0 ? void 0 : _a[0], (_b = b.value) === null || _b === void 0 ? void 0 : _b[0]) &&
                eqUndefinedByDate.equals((_c = a.value) === null || _c === void 0 ? void 0 : _c[1], (_d = b.value) === null || _d === void 0 ? void 0 : _d[1]));
        }
        else {
            return false;
        }
    },
};
var eqUndefinedDateFilterValue = getEq(eqDateFilterValue);
var eqPropFilterValue = {
    equals: function (a, b) {
        return eqUndefinedByDate.equals(a.after, b.after) &&
            eqUndefinedByDate.equals(a.before, b.before);
    },
};
var eqUndefinedPropFilterValue = getEq(eqPropFilterValue);
var isDateFilterType = function (e) {
    return e === 'date' || e === 'before' || e === 'after' || e === 'between';
};
Date.prototype.toStartOfDay = function () {
    var b = new Date(this);
    b.setHours(0, 0, 0, 0);
    return b;
};
Date.prototype.toEndOfDay = function () {
    var b = new Date(this);
    b.setHours(23, 59, 59, 999);
    return b;
};
var toFilterValue = function (v) {
    if (!!v.before && !!v.after) {
        return eqByDate.equals(v.after, v.before)
            ? { type: 'date', value: v.after.toStartOfDay() }
            : {
                type: 'between',
                value: [v.after.toStartOfDay(), v.before.toEndOfDay()],
            };
    }
    else if (!!v.before) {
        return {
            type: 'before',
            value: v.before.toEndOfDay(),
        };
    }
    else if (!!v.after) {
        return {
            type: 'after',
            value: v.after.toStartOfDay(),
        };
    }
    return undefined;
};
var fromFilterValue = function (v) {
    var _a, _b, _c, _d, _e, _f;
    switch (v.type) {
        case 'date':
            return {
                after: (_a = v.value) === null || _a === void 0 ? void 0 : _a.toStartOfDay(),
                before: (_b = v.value) === null || _b === void 0 ? void 0 : _b.toEndOfDay(),
            };
        case 'between':
            return {
                after: (_c = v.value) === null || _c === void 0 ? void 0 : _c[0].toStartOfDay(),
                before: (_d = v.value) === null || _d === void 0 ? void 0 : _d[1].toEndOfDay(),
            };
        case 'after':
            return { after: (_e = v.value) === null || _e === void 0 ? void 0 : _e.toStartOfDay() };
        case 'before':
            return { before: (_f = v.value) === null || _f === void 0 ? void 0 : _f.toEndOfDay() };
    }
};
var DateFilter = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var _b = React.useState(), filterValue = _b[0], setFilterValue = _b[1];
    var _c = React.useState(false), visible = _c[0], setVisible = _c[1];
    React.useEffect(function () {
        if (!(filterValue === null || filterValue === void 0 ? void 0 : filterValue.value)) {
            return;
        }
        var newFilterValue = !!value ? toFilterValue(value) : undefined;
        if (!eqUndefinedDateFilterValue.equals(filterValue, newFilterValue)) {
            setFilterValue(newFilterValue);
        }
    }, [value === null || value === void 0 ? void 0 : value.before, value === null || value === void 0 ? void 0 : value.after]);
    React.useEffect(function () {
        if (!onChange) {
            return;
        }
        var newPropValue = !!filterValue
            ? fromFilterValue(filterValue)
            : undefined;
        if (!eqUndefinedPropFilterValue.equals(value, newPropValue)) {
            onChange(newPropValue !== null && newPropValue !== void 0 ? newPropValue : {});
        }
    }, [filterValue === null || filterValue === void 0 ? void 0 : filterValue.type, filterValue === null || filterValue === void 0 ? void 0 : filterValue.value]);
    var active = ((filterValue === null || filterValue === void 0 ? void 0 : filterValue.type) === 'date' && !!(filterValue === null || filterValue === void 0 ? void 0 : filterValue.value)) ||
        ((filterValue === null || filterValue === void 0 ? void 0 : filterValue.type) === 'before' && !!(filterValue === null || filterValue === void 0 ? void 0 : filterValue.value)) ||
        ((filterValue === null || filterValue === void 0 ? void 0 : filterValue.type) === 'after' && !!(filterValue === null || filterValue === void 0 ? void 0 : filterValue.value)) ||
        ((filterValue === null || filterValue === void 0 ? void 0 : filterValue.type) === 'between' && !!(filterValue === null || filterValue === void 0 ? void 0 : filterValue.value));
    return (React.createElement(Dropdown, { trigger: ['click'], visible: visible, overlay: React.createElement(Card, { onMouseLeave: function () { return setVisible(false); } },
            React.createElement(Grid, { value: filterValue === null || filterValue === void 0 ? void 0 : filterValue.type, onChange: function (_a) {
                    var value = _a.target.value;
                    if (isDateFilterType(value)) {
                        setFilterValue(function (prev) {
                            return (prev === null || prev === void 0 ? void 0 : prev.type) === value
                                ? __assign(__assign({}, prev), { type: value })
                                : { type: value };
                        });
                    }
                } },
                React.createElement(Radio, { value: "date" },
                    React.createElement(TranslatedMessage, { id: "date" })),
                React.createElement(DatePicker, { value: (filterValue === null || filterValue === void 0 ? void 0 : filterValue.type) === 'date' && !!filterValue.value
                        ? moment(filterValue.value)
                        : null, onChange: function (v) {
                        return setFilterValue({ type: 'date', value: v === null || v === void 0 ? void 0 : v.toDate() });
                    }, disabled: (filterValue === null || filterValue === void 0 ? void 0 : filterValue.type) !== 'date' }),
                React.createElement(Radio, { value: "before" },
                    React.createElement(TranslatedMessage, { id: "before" })),
                React.createElement(DatePicker, { value: (filterValue === null || filterValue === void 0 ? void 0 : filterValue.type) === 'before' && !!filterValue.value
                        ? moment(filterValue.value)
                        : null, onChange: function (v) {
                        return setFilterValue({ type: 'before', value: v === null || v === void 0 ? void 0 : v.toDate() });
                    }, disabled: (filterValue === null || filterValue === void 0 ? void 0 : filterValue.type) !== 'before' }),
                React.createElement(Radio, { value: "after" },
                    React.createElement(TranslatedMessage, { id: "after" })),
                React.createElement(DatePicker, { value: (filterValue === null || filterValue === void 0 ? void 0 : filterValue.type) === 'after' && !!filterValue.value
                        ? moment(filterValue.value)
                        : null, onChange: function (v) {
                        return setFilterValue({ type: 'after', value: v === null || v === void 0 ? void 0 : v.toDate() });
                    }, disabled: (filterValue === null || filterValue === void 0 ? void 0 : filterValue.type) !== 'after' }),
                React.createElement(Radio, { value: "between" },
                    React.createElement(TranslatedMessage, { id: "between" })),
                React.createElement(DatePicker.RangePicker, { value: (filterValue === null || filterValue === void 0 ? void 0 : filterValue.type) === 'between' && !!filterValue.value
                        ? [moment(filterValue.value[0]), moment(filterValue.value[1])]
                        : null, onChange: function (v) {
                        return setFilterValue({
                            type: 'between',
                            value: !!(v === null || v === void 0 ? void 0 : v[0]) && !!(v === null || v === void 0 ? void 0 : v[1])
                                ? [v[0].toDate(), v[1].toDate()]
                                : undefined,
                        });
                    }, disabled: (filterValue === null || filterValue === void 0 ? void 0 : filterValue.type) !== 'between' }))) },
        React.createElement(CalendarButton, { active: active, onClick: function () { return setVisible(function (v) { return !v; }); } },
            (filterValue === null || filterValue === void 0 ? void 0 : filterValue.type) === 'date' && !!(filterValue === null || filterValue === void 0 ? void 0 : filterValue.value) ? (React.createElement(FormattedDate, { value: filterValue.value })) : (filterValue === null || filterValue === void 0 ? void 0 : filterValue.type) === 'before' && !!(filterValue === null || filterValue === void 0 ? void 0 : filterValue.value) ? (React.createElement(React.Fragment, null,
                React.createElement(TranslatedMessage, { id: "before" }),
                ' ',
                React.createElement(FormattedDate, { value: filterValue.value }))) : (filterValue === null || filterValue === void 0 ? void 0 : filterValue.type) === 'after' && !!(filterValue === null || filterValue === void 0 ? void 0 : filterValue.value) ? (React.createElement(React.Fragment, null,
                React.createElement(TranslatedMessage, { id: "after" }),
                ' ',
                React.createElement(FormattedDate, { value: filterValue.value }))) : (filterValue === null || filterValue === void 0 ? void 0 : filterValue.type) === 'between' && !!(filterValue === null || filterValue === void 0 ? void 0 : filterValue.value) ? (React.createElement(React.Fragment, null,
                React.createElement(TranslatedMessage, { id: "between" }),
                ' ',
                React.createElement(FormattedDate, { value: filterValue.value[0] }),
                ' ',
                React.createElement(FormattedDate, { value: filterValue.value[1] }))) : (React.createElement(TranslatedMessage, { id: "selectDate" })),
            React.createElement(CloseIcon, { onClick: function () { return setFilterValue(undefined); }, active: active, icon: React.createElement(CalendarOutlined, null) }))));
};
var templateObject_1$5, templateObject_2$1, templateObject_3$1;

var WideSelect = styled(Select)(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  min-width: 180px;\n"], ["\n  min-width: 180px;\n"])));
var StatusFilter = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    return (React.createElement(WideSelect, { placeholder: React.createElement(TranslatedMessage, { id: "transactionStatus" }), value: value, onChange: onChange, allowClear: true },
        React.createElement(Select.Option, { value: "Success" },
            React.createElement(TranslatedMessage, { id: "transactionStatus-Success" })),
        React.createElement(Select.Option, { value: "Pending" },
            React.createElement(TranslatedMessage, { id: "transactionStatus-Pending" })),
        React.createElement(Select.Option, { value: "Failed" },
            React.createElement(TranslatedMessage, { id: "transactionStatus-Failed" }))));
};
var templateObject_1$4;

var isFilterType = function (s) {
    return s === 'date' || s === 'status' || s === 'amount';
};
var FilterRow = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  gap: 24px;\n  justify-content: flex-start;\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: 24px;\n  justify-content: flex-start;\n"])));
var UselessMenu = styled(Menu)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 4px 0;\n  & .ant-menu-item {\n    margin: 0 !important;\n  }\n"], ["\n  padding: 4px 0;\n  & .ant-menu-item {\n    margin: 0 !important;\n  }\n"])));
var FilterButton = styled(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  min-width: 32px;\n  flex: 0;\n"], ["\n  min-width: 32px;\n  flex: 0;\n"])));
var TransactionFilter = function (_a) {
    var _b, _c, _d;
    var _e = _a.date, date = _e === void 0 ? true : _e, _f = _a.status, status = _f === void 0 ? true : _f, _g = _a.amount, amount = _g === void 0 ? true : _g, activeFilters = _a.activeFilters, toggleFilter = _a.toggleFilter, clearFilters = _a.clearFilters, value = _a.value, onChange = _a.onChange, units = _a.units;
    var _h = React.useState(false), dropdownVisible = _h[0], setDropdownVisible = _h[1];
    var _j = React.useState({
        date: date && ((_b = activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.date) !== null && _b !== void 0 ? _b : false),
        status: status && ((_c = activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.status) !== null && _c !== void 0 ? _c : false),
        amount: amount && ((_d = activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.amount) !== null && _d !== void 0 ? _d : false),
    }), selectedFilters = _j[0], setSelectedFilters = _j[1];
    // List of available filters.
    var availableFilters = pipe([date && 'date', status && 'status', amount && 'amount'], array.filter(function (v) { return !!v; }));
    // Update selected filter from props
    React.useEffect(function () {
        setSelectedFilters(function (p) {
            var _a, _b, _c;
            return ({
                date: date && ((_a = activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.date) !== null && _a !== void 0 ? _a : p.date),
                status: status && ((_b = activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.status) !== null && _b !== void 0 ? _b : p.status),
                amount: amount && ((_c = activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.amount) !== null && _c !== void 0 ? _c : p.amount),
            });
        });
    }, [
        date,
        status,
        amount,
        activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.date,
        activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.status,
        activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.amount,
    ]);
    // Update filter values when a selected filter is cleared
    React.useEffect(function () {
        if (!!onChange) {
            onChange(__assign(__assign({}, value), { date: selectedFilters.date ? value === null || value === void 0 ? void 0 : value.date : undefined, status: selectedFilters.status ? value === null || value === void 0 ? void 0 : value.status : undefined, amount: selectedFilters.amount ? value === null || value === void 0 ? void 0 : value.amount : undefined }));
        }
    }, [selectedFilters.date, selectedFilters.status, selectedFilters.amount]);
    return (React.createElement(FilterRow, null,
        React.createElement(Button, { onClick: function () {
                if (!!clearFilters) {
                    clearFilters();
                }
                else {
                    setSelectedFilters({ date: false, status: false, amount: false });
                }
            } },
            React.createElement(TranslatedMessage, { id: "clearFilters" })),
        React.createElement(Dropdown, { trigger: ['click'], visible: dropdownVisible, overlay: React.createElement(UselessMenu, { onMouseLeave: function () { return setDropdownVisible(false); } },
                React.createElement(Menu, { selectedKeys: pipe(selectedFilters, record.filter(function (v) { return v; }), record.keys), onClick: function (_a) {
                        var key = _a.key;
                        if (isFilterType(key)) {
                            if (!!toggleFilter) {
                                toggleFilter(key);
                            }
                            else {
                                setSelectedFilters(function (fs) {
                                    var _a;
                                    return (__assign(__assign({}, fs), (_a = {}, _a[key] = !fs[key], _a)));
                                });
                            }
                        }
                    } }, availableFilters.map(function (f) { return (React.createElement(Menu.Item, { key: f },
                    React.createElement(TranslatedMessage, { id: f }))); }))) },
            React.createElement(FilterButton, { type: "primary", icon: React.createElement(FilterOutlined, null), onClick: function () { return setDropdownVisible(function (v) { return !v; }); } })),
        selectedFilters.date && (React.createElement(DateFilter, { value: value === null || value === void 0 ? void 0 : value.date, onChange: function (date) { return onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, value), { date: date })); } })),
        selectedFilters.status && (React.createElement(StatusFilter, { value: value === null || value === void 0 ? void 0 : value.status, onChange: function (status) { return onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, value), { status: status })); } })),
        selectedFilters.amount && (React.createElement(AmountFilter$1, { value: value === null || value === void 0 ? void 0 : value.amount, onChange: function (amount) { return onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, value), { amount: amount })); }, units: units }))));
};
var TransactionFilter$1 = React.memo(TransactionFilter);
var templateObject_1$3, templateObject_2, templateObject_3;

var WorkspaceCard = function (ws) {
    var dispatch = useDispatch();
    if (ws.type === 'personal') {
        return (React__default.createElement(Card, { hoverable: true, size: "small", style: { textAlign: 'center' }, onClick: function () { return dispatch(selectOrganizationAction({ type: 'personal' })); } },
            React__default.createElement(Row, { align: "middle" },
                React__default.createElement(Col, { span: 6 },
                    React__default.createElement(Avatar, { icon: React__default.createElement(UserOutlined, null) })),
                React__default.createElement(Col, { span: 12 },
                    React__default.createElement(Typography.Title, { level: 5, type: "secondary", style: { marginBottom: '0px' } },
                        React__default.createElement(TranslatedMessage, { id: "personalAccount" }))),
                React__default.createElement(Col, { span: 6 },
                    React__default.createElement(ArrowRightOutlined, null)))));
    }
    return (React__default.createElement(Card, { key: ws.organization.name, hoverable: true, size: "small", style: { textAlign: 'center' }, onClick: function () {
            return dispatch(selectOrganizationAction({
                type: 'organization',
                organization: ws.organization.name,
            }));
        } },
        React__default.createElement(Row, { align: "middle" },
            React__default.createElement(Col, { span: 6 },
                React__default.createElement(Avatar, { icon: React__default.createElement(AppstoreOutlined, null) })),
            React__default.createElement(Col, { span: 12 },
                React__default.createElement(Typography.Title, { level: 5, type: "secondary", style: { marginBottom: '0px' } },
                    React__default.createElement(TranslatedMessage, { id: "organizationAccount", values: ws.organization }))),
            React__default.createElement(Col, { span: 6 },
                React__default.createElement(ArrowRightOutlined, null)))));
};
var OrganizationSelectModal = function () {
    var visible = useSelector(function (s) { return s.prosperus.organization.selectModalActive; });
    var workspacesOrLoading = useAvailableWorkspaces();
    var workspaces = workspacesOrLoading === 'Loading' ? [] : workspacesOrLoading;
    return (React__default.createElement(Modal, { width: 700, centered: true, title: "ProsperUs Accounts", visible: visible, closable: false, footer: null },
        React__default.createElement(Spin, { spinning: workspacesOrLoading === 'Loading' },
            React__default.createElement(Row, { justify: "center" },
                React__default.createElement(Space, { style: { width: '100%' }, direction: "vertical" },
                    workspaces.length === 0 && (React__default.createElement(Result, { status: "warning", title: React__default.createElement(TranslatedMessage, { id: "noWorkspaceOptions" }) })),
                    workspaces.map(function (ws) { return (React__default.createElement(WorkspaceCard, __assign({ key: ws.type === 'personal' ? ws.type : ws.organization.name }, ws))); }))))));
};

var SearchResult = t.type({
    count: t.number,
    profiles: t.array(Profile),
});
var defaultSearch = function (search, cancelToken) {
    return pipe(taskEither.tryCatch(function () {
        return axios.get('/dis/dis/1.0/profile', {
            cancelToken: cancelToken,
            params: {
                search: search,
                page: 0,
                itemsPerPage: 10,
            },
        });
    }, function (e) { return e; }), task.map(either.chain(function (response) {
        return SearchResult.decode(response.data);
    })), taskEither.map(function (res) { return res.profiles; }), taskEither.map(array.map(function (p) { return ({
        nym: p.nym,
        firstName: option.toUndefined(p.firstName),
        lastName: option.toUndefined(p.lastName),
    }); })));
};
var CenteredSpin = styled(Spin)(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var NymSelect = function (_a) {
    var placeholder = _a.placeholder, _b = _a.delayMS, delayMS = _b === void 0 ? 300 : _b, _c = _a.onSearch, onSearch = _c === void 0 ? defaultSearch : _c, className = _a.className, onChange = _a.onChange, value = _a.value;
    var _d = React.useState(NotRequested), results = _d[0], setResults = _d[1];
    var _e = React.useState(), search = _e[0], setSearch = _e[1];
    var cancelSource = React.useRef(axios.CancelToken.source());
    var timeoutRef = React.useRef();
    React.useEffect(function () {
        cancelSource.current.cancel();
        var prevTimeout = timeoutRef.current;
        if (!!prevTimeout) {
            clearTimeout(prevTimeout);
        }
        if (!!search) {
            var source = axios.CancelToken.source();
            cancelSource.current = source;
            setResults(Loading);
            timeoutRef.current = setTimeout(pipe(onSearch(search, source.token), task.map(either.fold(function (e) { return setResults(Err(e)); }, function (res) {
                console.log("setting results for search " + search + " found " + res.length);
                setResults(Ok(res));
            }))), delayMS);
        }
    }, [search]);
    console.log(results);
    return (React.createElement(React.Fragment, null,
        React.createElement(Select, { showSearch: true, labelInValue: true, allowClear: true, filterOption: false, className: className, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : React.createElement(TranslatedMessage, { id: "selectNymPrompt" }), value: !!value
                ? {
                    profile: value,
                    label: React.createElement(PeerWithNym, __assign({}, value)),
                    value: value.nym,
                }
                : undefined, onChange: function (_, opts) {
                // @ts-ignore
                onChange === null || onChange === void 0 ? void 0 : onChange(opts === null || opts === void 0 ? void 0 : opts.profile);
            }, onSearch: function (search) { return setSearch(search); }, options: pipe(results, loadable.toOption, option.map(array.map(function (profile) { return ({
                profile: profile,
                label: React.createElement(PeerWithNym, __assign({}, profile)),
                value: profile.nym,
            }); })), option.toUndefined), notFoundContent: loadable.isLoading(results) ? (React.createElement(CenteredSpin, { size: "small" })) : loadable.isErr(results) ? (React.createElement(Alert, { type: "error", showIcon: true, message: React.createElement(TranslatedMessage, { id: "searchFailed" }) })) : (React.createElement(Typography.Text, null,
                React.createElement(TranslatedMessage, { id: "noResults" }))) })));
};
var templateObject_1$2;

var PhonenumberInput = React__default.forwardRef(function (props, ref) {
    var onChange = props.onChange, country = props.country, value = props.value, onBlur = props.onBlur, onFocus = props.onFocus;
    var handleChange = useCallback(function (e) {
        if (!!onChange) {
            onChange(e.target.value);
        }
    }, [onChange]);
    var prefix = undefined;
    try {
        if (typeof value === 'string' && (value === null || value === void 0 ? void 0 : value.length) > 0 && (value === null || value === void 0 ? void 0 : value[0]) === '+') {
            prefix = '';
        }
        else {
            var code = getCountryCallingCode(country !== null && country !== void 0 ? country : '');
            console.debug('got code', code);
            prefix = '+' + code;
        }
    }
    catch (e) {
        console.debug('got exception', e);
        prefix = '';
    }
    return (React__default.createElement(Input, { id: "phone", prefix: prefix, name: "phonenumber", style: {
            width: '200px',
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
        }, defaultValue: value, value: value, onChange: handleChange, onBlur: onBlur, onFocus: onFocus, ref: ref, type: "tel", autoComplete: "tel" }));
});

var CustomSelect = styled(Select)(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  .ant-select-selection {\n    background-color: green;\n  }\n  & .ant-select-selector {\n    border-bottom-right-radius: 0px !important;\n    border-top-right-radius: 0px !important;\n  }\n"], ["\n  .ant-select-selection {\n    background-color: green;\n  }\n  & .ant-select-selector {\n    border-bottom-right-radius: 0px !important;\n    border-top-right-radius: 0px !important;\n  }\n"])));
var CountrySelect = function (_a) {
    var value = _a.value, onChange = _a.onChange, options = _a.options, rest = __rest(_a, ["value", "onChange", "options"]);
    var onChange_ = useCallback(function (value) {
        if (!!onChange) {
            onChange(value);
        }
    }, [onChange]);
    console.log('country in CountrySelect', value);
    return (React__default.createElement(CustomSelect, __assign({}, rest, { style: { width: 60, borderBottomRightRadius: 0, borderTopRightRadius: 0 }, value: value || 'ZZ', onChange: onChange_, showSearch: true, filterOption: function (input, option) { var _a; return (_a = option === null || option === void 0 ? void 0 : option.value) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(input.toLowerCase()); } }), (options !== null && options !== void 0 ? options : [])
        .filter(function (e) { return e.label !== 'International'; })
        .map(function (_a) {
        var value = _a.value;
        return (React__default.createElement(Select.Option, { key: value !== null && value !== void 0 ? value : 'ZZ', value: value !== null && value !== void 0 ? value : 'ZZ' },
            React__default.createElement("div", { className: "PhoneInputCountryFlag" },
                React__default.createElement("img", { style: { width: '25px', height: '25px' }, src: "http://purecatamphetamine.github.io/country-flag-icons/3x2/" + value + ".svg" }))));
    })));
};
var templateObject_1$1;

var PhonenumberWithCodeInput = function (_a) {
    var value = _a.value, onChange = _a.onChange, defaultCountry = _a.defaultCountry;
    return (React__default.createElement(PhoneInput, { value: value !== null && value !== void 0 ? value : '', 
        // @ts-ignore
        inputComponent: PhonenumberInput, countrySelectComponent: CountrySelect, defaultCountry: defaultCountry, country: defaultCountry, onChange: onChange !== null && onChange !== void 0 ? onChange : (function () { }) }));
};

var FullRedirect = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: calc(100% - ", "px);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  width: 100%;\n  height: 100%;\n"], ["\n  height: calc(100% - ", "px);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  width: 100%;\n  height: 100%;\n"])), function (props) { return props.theme.footerHeight; });
var PrivateRoute = function (_a) {
    var nodeEnv = _a.nodeEnv, rest = __rest(_a, ["nodeEnv"]);
    var isLoggedOut = useSelector(function (s) {
        return pipe(s.prosperus.account, loadable.caseOf({ Ok: function () { return false; }, Err: function () { return true; }, _: function () { return false; } }));
    });
    var isLoading = useSelector(function (s) {
        return loadable.isLoading(s.prosperus.account) ||
            loadable.isNotRequested(s.prosperus.account);
    });
    React.useEffect(function () {
        var _a;
        if (!isLoading && isLoggedOut) {
            var params = new URLSearchParams();
            params.set('redirect', window.location.pathname);
            if (nodeEnv !== 'development') {
                window.location.href = "/" + ((_a = applicationEnv.accountsPath) !== null && _a !== void 0 ? _a : 'accounts') + "/auth/login?" + params.toString();
            }
            else {
                if (!applicationEnv.login || !applicationEnv.password) {
                    console.debug('no login or password configured, please add LOGIN and PASSWORD environment variables to enable automatic login');
                    return;
                }
                axios.post('/auth/login', {
                    username: applicationEnv.login,
                    password: applicationEnv.password,
                }).then(function (r) {
                    document.cookie = "access_token=" + r.data.id_token + "; path=/";
                    document.cookie = "session_token=" + r.data.id_token + "; path=/";
                });
            }
        }
    }, [isLoggedOut, isLoading]);
    return isLoading ? (React.createElement(FullRedirect, null,
        React.createElement(Spin, { spinning: true }))) : !isLoggedOut ? (React.createElement(Route, __assign({}, rest))) : (React.createElement("div", null,
        React.createElement(FullRedirect, null,
            React.createElement(TranslatedMessage, { id: "redirecting" }))));
};
var templateObject_1;

function prosperusInitSaga(initEnv) {
    var _a, _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                if (!!initEnv) {
                    applicationEnv.allowPersonal =
                        (_a = initEnv.allowPersonal) !== null && _a !== void 0 ? _a : applicationEnv.allowPersonal;
                    applicationEnv.login =
                        (_b = initEnv.login) !== null && _b !== void 0 ? _b : applicationEnv.login;
                    applicationEnv.password =
                        (_c = initEnv.password) !== null && _c !== void 0 ? _c : applicationEnv.password;
                    applicationEnv.activeModules =
                        (_d = initEnv.activeModules) !== null && _d !== void 0 ? _d : applicationEnv.activeModules;
                    applicationEnv.accountsPath =
                        (_e = initEnv.accountsPath) !== null && _e !== void 0 ? _e : applicationEnv.accountsPath;
                }
                return [4 /*yield*/, effects.put(getAccountAction())];
            case 1:
                _f.sent();
                return [2 /*return*/];
        }
    });
}
function getUnitsSaga(_) {
    var response, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, effects.call(axios.get, '/dcn/dcn1.0/units')];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, effects.put(pipe(SimpleUnits.decode(response.data), foldEitherToAction(getUnitsResult)))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_1 = _a.sent();
                return [4 /*yield*/, effects.put(getUnitsResult.err(e_1))];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function getDCNNymID(_) {
    var response, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, effects.call(axios.get, '/dcn/dcn1.0/nym-id')];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, effects.put(pipe(string$1.decode(response.data), foldEitherToAction(getNymIDResult)))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_2 = _a.sent();
                return [4 /*yield*/, effects.put(getNymIDResult.err(e_2))];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function prosperusSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects.all([
                    effects.takeLeading('@react-tookit/get_units', getUnitsSaga),
                    effects.takeLeading('@react-tookit/get_nym_id', getDCNNymID),
                    saga$1(),
                    saga(),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var prosperusReducer = /*#__PURE__*/ combineReducers({
    account: reducer,
    organization: reducer$1,
    units: function (s, a) {
        if (s === void 0) { s = NotRequested; }
        switch (a.type) {
            case '@react-tookit/get_units':
                return Loading;
            case '@react-tookit/get_units_result':
                return a.payload;
            default:
                return s;
        }
    },
    dcnNymID: function (s, a) {
        if (s === void 0) { s = NotRequested; }
        switch (a.type) {
            case '@react-tookit/get_nym_id':
                return Loading;
            case '@react-tookit/get_nym_id_result':
                return a.payload;
            default:
                return s;
        }
    },
});
var mockReducer = /*#__PURE__*/ combineReducers({
    prosperus: prosperusReducer,
});

export { AccountOrganizationInfo, AccountSettingsDropDown, Action, AmountWithAssetName, AnimatedMenu, Authority, Balance, BalanceCarousel, CIN, Carousel, DateString, EmailAddress, EnrichedTransfer, Err, ExpandedTransactionRow, FailableAction, Header, Loading, Locale, MemoedC, Metadata, Module, ModulePermissions, NotRequested, NymSelect, Ok, Organization, OrganizationSelectModal, OrganizationUser, OverviewTransactionTable as OverviewTransactionsTable, PayloadAction, Peer, PeerWithNym, Peers$1 as Peers, Permission, PhonenumberWithCodeInput as PhoneInput, Phonenumber, PrivateRoute, Profile, SignatureInfo, Signatures, SimpleUnit, SimpleUnits, Transaction, TransactionDetails, TransactionFilter$1 as TransactionFilter, TransactionResult, TransactionStatus, TransactionType, TransactionsTable, Transfer, TranslatedMessage, UAAAccount, UserBase, UserState, UserStateWithName, WalletBalanceCard, WalletBalancesCarousel, WalletPermissions, WorkspacesSubMenu, actionCreator, addMessages, allModules, anyLess, applicationDefinitions, applicationEnv, balanceSumMonoid, contactQR, emptyAccount, emptyMetadata, emptyOrganization, emptyProfile, emptyUserState, enrichedTransferOrd, eqBalance, eqEnrichedTransfer, eqMetadata, eqPeer, eqPeers, eqProfile, eqSignatureInfo, eqSignatures, eqTransactionResult, eqTransfer, eqUserState, failableActionCreator, foldEitherToAction, getAccountAction, getAccountResultAction, getAmount, getCurrentWorkspaceAction, getCurrentWorkspaceResultAction, getDCNNym, getNymIDAction, getNymIDResult, getParsedFormat, getRecordKeys, getUnitsAction, getUnitsResult, hasRequiredModulePermissions, loadable, localNames, locales, initialState as loginInitialState, reducer as loginReducer, saga as loginSaga, logoutAction, logoutResultAction, memoed, mockReducer, noopAction, openSelectWorkspaceModalAction, ordBalance, ordPeerBalances, ordPeerBalancesWithPriority, initialState$1 as organizationInitialState, reducer$1 as organizationReducer, saga$1 as organizationSaga, payloadActionCreator, performIfNotRequested, prosperusInitSaga, prosperusReducer, prosperusSaga, result, selectOrganizationAction, translatedMessage, useAccount, useAvailableWorkspaces, useAvatarURL, useCurrentWorkspace, useOrganization, useOrganizationPermissions, useUnits, waitForAccount, waitForWorkspace };
